// source: all.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var brank_as_gunk_b$enterprise_v1_addresstag_all_pb = require('./../addresstag/all_pb.js');
goog.object.extend(proto, brank_as_gunk_b$enterprise_v1_addresstag_all_pb);
var brank_as_gunk_b$enterprise_v1_income_all_pb = require('./../income/all_pb.js');
goog.object.extend(proto, brank_as_gunk_b$enterprise_v1_income_all_pb);
goog.exportSymbol('proto.fastcheckout.Account', null, global);
goog.exportSymbol('proto.fastcheckout.AccountInfo', null, global);
goog.exportSymbol('proto.fastcheckout.AccountInfoType', null, global);
goog.exportSymbol('proto.fastcheckout.AccountMetadata', null, global);
goog.exportSymbol('proto.fastcheckout.AccountStatement', null, global);
goog.exportSymbol('proto.fastcheckout.AccountType', null, global);
goog.exportSymbol('proto.fastcheckout.AdditionalDetails', null, global);
goog.exportSymbol('proto.fastcheckout.Address', null, global);
goog.exportSymbol('proto.fastcheckout.Amount', null, global);
goog.exportSymbol('proto.fastcheckout.AmountBreakdown', null, global);
goog.exportSymbol('proto.fastcheckout.BankCode', null, global);
goog.exportSymbol('proto.fastcheckout.BankInfo', null, global);
goog.exportSymbol('proto.fastcheckout.BankInteractionMethod', null, global);
goog.exportSymbol('proto.fastcheckout.BusinessInfo', null, global);
goog.exportSymbol('proto.fastcheckout.CallbackURLStatus', null, global);
goog.exportSymbol('proto.fastcheckout.Challenge', null, global);
goog.exportSymbol('proto.fastcheckout.ChallengeType', null, global);
goog.exportSymbol('proto.fastcheckout.Charge', null, global);
goog.exportSymbol('proto.fastcheckout.Client', null, global);
goog.exportSymbol('proto.fastcheckout.CountryISO3166', null, global);
goog.exportSymbol('proto.fastcheckout.Credential', null, global);
goog.exportSymbol('proto.fastcheckout.CredentialType', null, global);
goog.exportSymbol('proto.fastcheckout.CurrencyISO4217', null, global);
goog.exportSymbol('proto.fastcheckout.Customer', null, global);
goog.exportSymbol('proto.fastcheckout.DestinationAccount', null, global);
goog.exportSymbol('proto.fastcheckout.DestinationAccountInfo', null, global);
goog.exportSymbol('proto.fastcheckout.DestinationBankCode', null, global);
goog.exportSymbol('proto.fastcheckout.DestinationBankInfo', null, global);
goog.exportSymbol('proto.fastcheckout.Discount', null, global);
goog.exportSymbol('proto.fastcheckout.EcommerceAddress', null, global);
goog.exportSymbol('proto.fastcheckout.EcommerceData', null, global);
goog.exportSymbol('proto.fastcheckout.Fee', null, global);
goog.exportSymbol('proto.fastcheckout.FetchAccountsTaskStatus', null, global);
goog.exportSymbol('proto.fastcheckout.FetchSourceAccountsTask', null, global);
goog.exportSymbol('proto.fastcheckout.Filter', null, global);
goog.exportSymbol('proto.fastcheckout.FilterField', null, global);
goog.exportSymbol('proto.fastcheckout.FundTransferFee', null, global);
goog.exportSymbol('proto.fastcheckout.FundTransferLimit', null, global);
goog.exportSymbol('proto.fastcheckout.FundTransferTask', null, global);
goog.exportSymbol('proto.fastcheckout.FundTransferTaskStatus', null, global);
goog.exportSymbol('proto.fastcheckout.GCashAddress', null, global);
goog.exportSymbol('proto.fastcheckout.GCashCustomer', null, global);
goog.exportSymbol('proto.fastcheckout.GopayCustomer', null, global);
goog.exportSymbol('proto.fastcheckout.Instalment', null, global);
goog.exportSymbol('proto.fastcheckout.Interest', null, global);
goog.exportSymbol('proto.fastcheckout.InterestType', null, global);
goog.exportSymbol('proto.fastcheckout.InvoiceDetails', null, global);
goog.exportSymbol('proto.fastcheckout.IssueType', null, global);
goog.exportSymbol('proto.fastcheckout.Language', null, global);
goog.exportSymbol('proto.fastcheckout.Limits', null, global);
goog.exportSymbol('proto.fastcheckout.LineItem', null, global);
goog.exportSymbol('proto.fastcheckout.Loan', null, global);
goog.exportSymbol('proto.fastcheckout.LocalTime', null, global);
goog.exportSymbol('proto.fastcheckout.Location', null, global);
goog.exportSymbol('proto.fastcheckout.Metadata', null, global);
goog.exportSymbol('proto.fastcheckout.OptionalChallengeType', null, global);
goog.exportSymbol('proto.fastcheckout.Order', null, global);
goog.exportSymbol('proto.fastcheckout.PaymentChannelType', null, global);
goog.exportSymbol('proto.fastcheckout.Product', null, global);
goog.exportSymbol('proto.fastcheckout.ProductMetadata', null, global);
goog.exportSymbol('proto.fastcheckout.QRCode', null, global);
goog.exportSymbol('proto.fastcheckout.Report', null, global);
goog.exportSymbol('proto.fastcheckout.ReportStatus', null, global);
goog.exportSymbol('proto.fastcheckout.ReportType', null, global);
goog.exportSymbol('proto.fastcheckout.Settlement', null, global);
goog.exportSymbol('proto.fastcheckout.SettlementResponseCode', null, global);
goog.exportSymbol('proto.fastcheckout.Statement', null, global);
goog.exportSymbol('proto.fastcheckout.StatementStatus', null, global);
goog.exportSymbol('proto.fastcheckout.StatementSubStatus', null, global);
goog.exportSymbol('proto.fastcheckout.StatementTask', null, global);
goog.exportSymbol('proto.fastcheckout.StatementTaskStatus', null, global);
goog.exportSymbol('proto.fastcheckout.Transaction', null, global);
goog.exportSymbol('proto.fastcheckout.TransactionLog', null, global);
goog.exportSymbol('proto.fastcheckout.TransactionStatus', null, global);
goog.exportSymbol('proto.fastcheckout.TransactionType', null, global);
goog.exportSymbol('proto.fastcheckout.Transaction_Fields', null, global);
goog.exportSymbol('proto.fastcheckout.UnpaidInstalment', null, global);
goog.exportSymbol('proto.fastcheckout.Via', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Account = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Account.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Account, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Account.displayName = 'proto.fastcheckout.Account';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.EcommerceData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.EcommerceData.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.EcommerceData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.EcommerceData.displayName = 'proto.fastcheckout.EcommerceData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Order.displayName = 'proto.fastcheckout.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Transaction_Fields = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Transaction_Fields, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Transaction_Fields.displayName = 'proto.fastcheckout.Transaction_Fields';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Transaction.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Transaction.displayName = 'proto.fastcheckout.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Loan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Loan.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Loan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Loan.displayName = 'proto.fastcheckout.Loan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Instalment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Instalment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Instalment.displayName = 'proto.fastcheckout.Instalment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.UnpaidInstalment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.UnpaidInstalment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.UnpaidInstalment.displayName = 'proto.fastcheckout.UnpaidInstalment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Interest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Interest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Interest.displayName = 'proto.fastcheckout.Interest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.EcommerceAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.EcommerceAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.EcommerceAddress.displayName = 'proto.fastcheckout.EcommerceAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Product = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Product, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Product.displayName = 'proto.fastcheckout.Product';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Location.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Location.displayName = 'proto.fastcheckout.Location';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.GopayCustomer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.GopayCustomer.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.GopayCustomer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.GopayCustomer.displayName = 'proto.fastcheckout.GopayCustomer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.GCashAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.GCashAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.GCashAddress.displayName = 'proto.fastcheckout.GCashAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.GCashCustomer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.GCashCustomer.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.GCashCustomer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.GCashCustomer.displayName = 'proto.fastcheckout.GCashCustomer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.AccountMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.AccountMetadata.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.AccountMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.AccountMetadata.displayName = 'proto.fastcheckout.AccountMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Metadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Metadata.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Metadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Metadata.displayName = 'proto.fastcheckout.Metadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.ProductMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.ProductMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.ProductMetadata.displayName = 'proto.fastcheckout.ProductMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Statement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.Statement.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.Statement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Statement.displayName = 'proto.fastcheckout.Statement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.LocalTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.LocalTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.LocalTime.displayName = 'proto.fastcheckout.LocalTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Challenge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Challenge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Challenge.displayName = 'proto.fastcheckout.Challenge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.AccountStatement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.AccountStatement.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.AccountStatement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.AccountStatement.displayName = 'proto.fastcheckout.AccountStatement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.StatementTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.StatementTask.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.StatementTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.StatementTask.displayName = 'proto.fastcheckout.StatementTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.FundTransferTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.FundTransferTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.FundTransferTask.displayName = 'proto.fastcheckout.FundTransferTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.AdditionalDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.AdditionalDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.AdditionalDetails.displayName = 'proto.fastcheckout.AdditionalDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.QRCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.QRCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.QRCode.displayName = 'proto.fastcheckout.QRCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Settlement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Settlement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Settlement.displayName = 'proto.fastcheckout.Settlement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Filter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Filter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Filter.displayName = 'proto.fastcheckout.Filter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.FilterField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.FilterField.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.FilterField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.FilterField.displayName = 'proto.fastcheckout.FilterField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.FetchSourceAccountsTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.FetchSourceAccountsTask.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.FetchSourceAccountsTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.FetchSourceAccountsTask.displayName = 'proto.fastcheckout.FetchSourceAccountsTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.BusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.BusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.BusinessInfo.displayName = 'proto.fastcheckout.BusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.DestinationAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.DestinationAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.DestinationAccount.displayName = 'proto.fastcheckout.DestinationAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Client.displayName = 'proto.fastcheckout.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Report = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Report, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Report.displayName = 'proto.fastcheckout.Report';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.TransactionLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.TransactionLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.TransactionLog.displayName = 'proto.fastcheckout.TransactionLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.BankInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.BankInfo.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.BankInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.BankInfo.displayName = 'proto.fastcheckout.BankInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.DestinationBankInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.DestinationBankInfo.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.DestinationBankInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.DestinationBankInfo.displayName = 'proto.fastcheckout.DestinationBankInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.FundTransferLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.FundTransferLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.FundTransferLimit.displayName = 'proto.fastcheckout.FundTransferLimit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Limits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Limits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Limits.displayName = 'proto.fastcheckout.Limits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.FundTransferFee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.FundTransferFee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.FundTransferFee.displayName = 'proto.fastcheckout.FundTransferFee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Fee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Fee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Fee.displayName = 'proto.fastcheckout.Fee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Amount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Amount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Amount.displayName = 'proto.fastcheckout.Amount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.AmountBreakdown = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.AmountBreakdown, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.AmountBreakdown.displayName = 'proto.fastcheckout.AmountBreakdown';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.AccountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.AccountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.AccountInfo.displayName = 'proto.fastcheckout.AccountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.DestinationAccountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.DestinationAccountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.DestinationAccountInfo.displayName = 'proto.fastcheckout.DestinationAccountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Credential = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Credential, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Credential.displayName = 'proto.fastcheckout.Credential';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Customer.displayName = 'proto.fastcheckout.Customer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Address.displayName = 'proto.fastcheckout.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.InvoiceDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fastcheckout.InvoiceDetails.repeatedFields_, null);
};
goog.inherits(proto.fastcheckout.InvoiceDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.InvoiceDetails.displayName = 'proto.fastcheckout.InvoiceDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.LineItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.LineItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.LineItem.displayName = 'proto.fastcheckout.LineItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Charge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Charge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Charge.displayName = 'proto.fastcheckout.Charge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fastcheckout.Discount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fastcheckout.Discount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fastcheckout.Discount.displayName = 'proto.fastcheckout.Discount';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Account.repeatedFields_ = [3,16,17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Account.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Account.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Account} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Account.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    owneridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    accountnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    nick: jspb.Message.getFieldWithDefault(msg, 5, ""),
    balance: (f = msg.getBalance()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    holdername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 8, 0),
    accountreference: jspb.Message.getFieldWithDefault(msg, 9, ""),
    totalamountcredited: (f = msg.getTotalamountcredited()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    totalamountdebited: (f = msg.getTotalamountdebited()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    credittransactioncount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    debittransactioncount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    holderaddress: jspb.Message.getFieldWithDefault(msg, 14, ""),
    additionaldata: jspb.Message.getFieldWithDefault(msg, 15, ""),
    accountmetadataList: jspb.Message.toObjectList(msg.getAccountmetadataList(),
    proto.fastcheckout.AccountMetadata.toObject, includeInstance),
    ecommerceaddressesList: jspb.Message.toObjectList(msg.getEcommerceaddressesList(),
    proto.fastcheckout.EcommerceAddress.toObject, includeInstance),
    accountpocketname: jspb.Message.getFieldWithDefault(msg, 18, ""),
    accountcardnumber: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Account}
 */
proto.fastcheckout.Account.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Account;
  return proto.fastcheckout.Account.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Account} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Account}
 */
proto.fastcheckout.Account.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountid(value);
      break;
    case 2:
      var value = /** @type {!proto.fastcheckout.AccountType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addOwnerids(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNick(value);
      break;
    case 6:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldername(value);
      break;
    case 8:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountreference(value);
      break;
    case 10:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setTotalamountcredited(value);
      break;
    case 11:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setTotalamountdebited(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCredittransactioncount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDebittransactioncount(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderaddress(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionaldata(value);
      break;
    case 16:
      var value = new proto.fastcheckout.AccountMetadata;
      reader.readMessage(value,proto.fastcheckout.AccountMetadata.deserializeBinaryFromReader);
      msg.addAccountmetadata(value);
      break;
    case 17:
      var value = new proto.fastcheckout.EcommerceAddress;
      reader.readMessage(value,proto.fastcheckout.EcommerceAddress.deserializeBinaryFromReader);
      msg.addEcommerceaddresses(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountpocketname(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountcardnumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Account.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Account.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Account} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Account.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getOwneridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNick();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getHoldername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAccountreference();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTotalamountcredited();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getTotalamountdebited();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getCredittransactioncount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getDebittransactioncount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getHolderaddress();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAdditionaldata();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAccountmetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.fastcheckout.AccountMetadata.serializeBinaryToWriter
    );
  }
  f = message.getEcommerceaddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.fastcheckout.EcommerceAddress.serializeBinaryToWriter
    );
  }
  f = message.getAccountpocketname();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAccountcardnumber();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string AccountID = 1;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAccountid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AccountType Type = 2;
 * @return {!proto.fastcheckout.AccountType}
 */
proto.fastcheckout.Account.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.AccountType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fastcheckout.AccountType} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated string OwnerIds = 3;
 * @return {!Array<string>}
 */
proto.fastcheckout.Account.prototype.getOwneridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setOwneridsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.addOwnerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearOwneridsList = function() {
  return this.setOwneridsList([]);
};


/**
 * optional string AccountNumber = 4;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Nick = 5;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getNick = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setNick = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Amount Balance = 6;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Account.prototype.getBalance = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 6));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Account} returns this
*/
proto.fastcheckout.Account.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Account.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string HolderName = 7;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getHoldername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setHoldername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional BankCode BankCode = 8;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.Account.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string AccountReference = 9;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAccountreference = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAccountreference = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional Amount TotalAmountCredited = 10;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Account.prototype.getTotalamountcredited = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 10));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Account} returns this
*/
proto.fastcheckout.Account.prototype.setTotalamountcredited = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearTotalamountcredited = function() {
  return this.setTotalamountcredited(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Account.prototype.hasTotalamountcredited = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Amount TotalAmountDebited = 11;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Account.prototype.getTotalamountdebited = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 11));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Account} returns this
*/
proto.fastcheckout.Account.prototype.setTotalamountdebited = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearTotalamountdebited = function() {
  return this.setTotalamountdebited(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Account.prototype.hasTotalamountdebited = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 CreditTransactionCount = 12;
 * @return {number}
 */
proto.fastcheckout.Account.prototype.getCredittransactioncount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setCredittransactioncount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 DebitTransactionCount = 13;
 * @return {number}
 */
proto.fastcheckout.Account.prototype.getDebittransactioncount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setDebittransactioncount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string HolderAddress = 14;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getHolderaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setHolderaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string AdditionalData = 15;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAdditionaldata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAdditionaldata = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated AccountMetadata AccountMetadata = 16;
 * @return {!Array<!proto.fastcheckout.AccountMetadata>}
 */
proto.fastcheckout.Account.prototype.getAccountmetadataList = function() {
  return /** @type{!Array<!proto.fastcheckout.AccountMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.AccountMetadata, 16));
};


/**
 * @param {!Array<!proto.fastcheckout.AccountMetadata>} value
 * @return {!proto.fastcheckout.Account} returns this
*/
proto.fastcheckout.Account.prototype.setAccountmetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.fastcheckout.AccountMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.AccountMetadata}
 */
proto.fastcheckout.Account.prototype.addAccountmetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.fastcheckout.AccountMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearAccountmetadataList = function() {
  return this.setAccountmetadataList([]);
};


/**
 * repeated EcommerceAddress EcommerceAddresses = 17;
 * @return {!Array<!proto.fastcheckout.EcommerceAddress>}
 */
proto.fastcheckout.Account.prototype.getEcommerceaddressesList = function() {
  return /** @type{!Array<!proto.fastcheckout.EcommerceAddress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.EcommerceAddress, 17));
};


/**
 * @param {!Array<!proto.fastcheckout.EcommerceAddress>} value
 * @return {!proto.fastcheckout.Account} returns this
*/
proto.fastcheckout.Account.prototype.setEcommerceaddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.fastcheckout.EcommerceAddress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.EcommerceAddress}
 */
proto.fastcheckout.Account.prototype.addEcommerceaddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.fastcheckout.EcommerceAddress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.clearEcommerceaddressesList = function() {
  return this.setEcommerceaddressesList([]);
};


/**
 * optional string AccountPocketName = 18;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAccountpocketname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAccountpocketname = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string AccountCardNumber = 19;
 * @return {string}
 */
proto.fastcheckout.Account.prototype.getAccountcardnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Account} returns this
 */
proto.fastcheckout.Account.prototype.setAccountcardnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.EcommerceData.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.EcommerceData.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.EcommerceData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.EcommerceData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.EcommerceData.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalorderprice: (f = msg.getTotalorderprice()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.fastcheckout.Order.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.EcommerceData}
 */
proto.fastcheckout.EcommerceData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.EcommerceData;
  return proto.fastcheckout.EcommerceData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.EcommerceData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.EcommerceData}
 */
proto.fastcheckout.EcommerceData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setTotalorderprice(value);
      break;
    case 3:
      var value = new proto.fastcheckout.Order;
      reader.readMessage(value,proto.fastcheckout.Order.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.EcommerceData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.EcommerceData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.EcommerceData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.EcommerceData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalorderprice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fastcheckout.Order.serializeBinaryToWriter
    );
  }
};


/**
 * optional string OrderID = 1;
 * @return {string}
 */
proto.fastcheckout.EcommerceData.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceData} returns this
 */
proto.fastcheckout.EcommerceData.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Amount TotalOrderPrice = 2;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.EcommerceData.prototype.getTotalorderprice = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 2));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.EcommerceData} returns this
*/
proto.fastcheckout.EcommerceData.prototype.setTotalorderprice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.EcommerceData} returns this
 */
proto.fastcheckout.EcommerceData.prototype.clearTotalorderprice = function() {
  return this.setTotalorderprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.EcommerceData.prototype.hasTotalorderprice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Order Orders = 3;
 * @return {!Array<!proto.fastcheckout.Order>}
 */
proto.fastcheckout.EcommerceData.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.fastcheckout.Order>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Order, 3));
};


/**
 * @param {!Array<!proto.fastcheckout.Order>} value
 * @return {!proto.fastcheckout.EcommerceData} returns this
*/
proto.fastcheckout.EcommerceData.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fastcheckout.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Order}
 */
proto.fastcheckout.EcommerceData.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fastcheckout.Order, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.EcommerceData} returns this
 */
proto.fastcheckout.EcommerceData.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Order.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: (f = msg.getPrice()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    qty: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalsubprice: (f = msg.getTotalsubprice()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    merchant: jspb.Message.getFieldWithDefault(msg, 5, ""),
    category: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Order}
 */
proto.fastcheckout.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Order;
  return proto.fastcheckout.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Order}
 */
proto.fastcheckout.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQty(value);
      break;
    case 4:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setTotalsubprice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchant(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getQty();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalsubprice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getMerchant();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.fastcheckout.Order.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Amount Price = 2;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Order.prototype.getPrice = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 2));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Order} returns this
*/
proto.fastcheckout.Order.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Order.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 Qty = 3;
 * @return {number}
 */
proto.fastcheckout.Order.prototype.getQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.setQty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional Amount TotalSubPrice = 4;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Order.prototype.getTotalsubprice = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 4));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Order} returns this
*/
proto.fastcheckout.Order.prototype.setTotalsubprice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.clearTotalsubprice = function() {
  return this.setTotalsubprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Order.prototype.hasTotalsubprice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string Merchant = 5;
 * @return {string}
 */
proto.fastcheckout.Order.prototype.getMerchant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.setMerchant = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Category = 6;
 * @return {string}
 */
proto.fastcheckout.Order.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Order} returns this
 */
proto.fastcheckout.Order.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Transaction_Fields.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Transaction_Fields.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Transaction_Fields} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Transaction_Fields.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    memo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountno: jspb.Message.getFieldWithDefault(msg, 3, ""),
    company: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Transaction_Fields}
 */
proto.fastcheckout.Transaction_Fields.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Transaction_Fields;
  return proto.fastcheckout.Transaction_Fields.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Transaction_Fields} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Transaction_Fields}
 */
proto.fastcheckout.Transaction_Fields.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountno(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompany(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Transaction_Fields.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Transaction_Fields.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Transaction_Fields} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Transaction_Fields.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMemo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountno();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCompany();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.fastcheckout.Transaction_Fields.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction_Fields} returns this
 */
proto.fastcheckout.Transaction_Fields.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Memo = 2;
 * @return {string}
 */
proto.fastcheckout.Transaction_Fields.prototype.getMemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction_Fields} returns this
 */
proto.fastcheckout.Transaction_Fields.prototype.setMemo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AccountNo = 3;
 * @return {string}
 */
proto.fastcheckout.Transaction_Fields.prototype.getAccountno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction_Fields} returns this
 */
proto.fastcheckout.Transaction_Fields.prototype.setAccountno = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Company = 4;
 * @return {string}
 */
proto.fastcheckout.Transaction_Fields.prototype.getCompany = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction_Fields} returns this
 */
proto.fastcheckout.Transaction_Fields.prototype.setCompany = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Transaction.repeatedFields_ = [12,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    amount: (f = msg.getAmount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    descriptor: jspb.Message.getFieldWithDefault(msg, 6, ""),
    matchid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    from: (f = msg.getFrom()) && proto.fastcheckout.Account.toObject(includeInstance, f),
    to: (f = msg.getTo()) && proto.fastcheckout.Account.toObject(includeInstance, f),
    fields: (f = msg.getFields()) && proto.fastcheckout.Transaction_Fields.toObject(includeInstance, f),
    balance: (f = msg.getBalance()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    merchanttypeList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    accounttransactionhash: jspb.Message.getFieldWithDefault(msg, 13, ""),
    localtime: jspb.Message.getFieldWithDefault(msg, 14, ""),
    confidence: jspb.Message.getFieldWithDefault(msg, 15, ""),
    googlemaptypeList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    product: (f = msg.getProduct()) && proto.fastcheckout.Product.toObject(includeInstance, f),
    additionaldata: jspb.Message.getFieldWithDefault(msg, 18, ""),
    metadata: (f = msg.getMetadata()) && proto.fastcheckout.Metadata.toObject(includeInstance, f),
    category: jspb.Message.getFieldWithDefault(msg, 20, ""),
    ecommercedata: (f = msg.getEcommercedata()) && proto.fastcheckout.EcommerceData.toObject(includeInstance, f),
    error: jspb.Message.getFieldWithDefault(msg, 22, ""),
    sequence: jspb.Message.getFieldWithDefault(msg, 23, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Transaction}
 */
proto.fastcheckout.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Transaction;
  return proto.fastcheckout.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Transaction}
 */
proto.fastcheckout.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.TransactionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.TransactionStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescriptor(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchid(value);
      break;
    case 8:
      var value = new proto.fastcheckout.Account;
      reader.readMessage(value,proto.fastcheckout.Account.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 9:
      var value = new proto.fastcheckout.Account;
      reader.readMessage(value,proto.fastcheckout.Account.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 10:
      var value = new proto.fastcheckout.Transaction_Fields;
      reader.readMessage(value,proto.fastcheckout.Transaction_Fields.deserializeBinaryFromReader);
      msg.setFields(value);
      break;
    case 11:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setBalance(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addMerchanttype(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccounttransactionhash(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocaltime(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidence(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addGooglemaptype(value);
      break;
    case 17:
      var value = new proto.fastcheckout.Product;
      reader.readMessage(value,proto.fastcheckout.Product.deserializeBinaryFromReader);
      msg.setProduct(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdditionaldata(value);
      break;
    case 19:
      var value = new proto.fastcheckout.Metadata;
      reader.readMessage(value,proto.fastcheckout.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 21:
      var value = new proto.fastcheckout.EcommerceData;
      reader.readMessage(value,proto.fastcheckout.EcommerceData.deserializeBinaryFromReader);
      msg.setEcommercedata(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSequence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getDescriptor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMatchid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.fastcheckout.Account.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.fastcheckout.Account.serializeBinaryToWriter
    );
  }
  f = message.getFields();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fastcheckout.Transaction_Fields.serializeBinaryToWriter
    );
  }
  f = message.getBalance();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getMerchanttypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getAccounttransactionhash();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLocaltime();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getConfidence();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getGooglemaptypeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getProduct();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.fastcheckout.Product.serializeBinaryToWriter
    );
  }
  f = message.getAdditionaldata();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.fastcheckout.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getEcommercedata();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.fastcheckout.EcommerceData.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getSequence();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
};


/**
 * optional string TransactionID = 1;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setTransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp Date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Transaction.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TransactionType Type = 3;
 * @return {!proto.fastcheckout.TransactionType}
 */
proto.fastcheckout.Transaction.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.TransactionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.TransactionType} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional TransactionStatus Status = 4;
 * @return {!proto.fastcheckout.TransactionStatus}
 */
proto.fastcheckout.Transaction.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.TransactionStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.TransactionStatus} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Amount Amount = 5;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Transaction.prototype.getAmount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 5));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string Descriptor = 6;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getDescriptor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setDescriptor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string MatchID = 7;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getMatchid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setMatchid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Account From = 8;
 * @return {?proto.fastcheckout.Account}
 */
proto.fastcheckout.Transaction.prototype.getFrom = function() {
  return /** @type{?proto.fastcheckout.Account} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Account, 8));
};


/**
 * @param {?proto.fastcheckout.Account|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Account To = 9;
 * @return {?proto.fastcheckout.Account}
 */
proto.fastcheckout.Transaction.prototype.getTo = function() {
  return /** @type{?proto.fastcheckout.Account} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Account, 9));
};


/**
 * @param {?proto.fastcheckout.Account|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasTo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Transaction_Fields Fields = 10;
 * @return {?proto.fastcheckout.Transaction_Fields}
 */
proto.fastcheckout.Transaction.prototype.getFields = function() {
  return /** @type{?proto.fastcheckout.Transaction_Fields} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Transaction_Fields, 10));
};


/**
 * @param {?proto.fastcheckout.Transaction_Fields|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setFields = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearFields = function() {
  return this.setFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasFields = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Amount Balance = 11;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Transaction.prototype.getBalance = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 11));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setBalance = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearBalance = function() {
  return this.setBalance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasBalance = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated string MerchantType = 12;
 * @return {!Array<string>}
 */
proto.fastcheckout.Transaction.prototype.getMerchanttypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setMerchanttypeList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.addMerchanttype = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearMerchanttypeList = function() {
  return this.setMerchanttypeList([]);
};


/**
 * optional string AccountTransactionHash = 13;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getAccounttransactionhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setAccounttransactionhash = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string LocalTime = 14;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getLocaltime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setLocaltime = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string Confidence = 15;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getConfidence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string GoogleMapType = 16;
 * @return {!Array<string>}
 */
proto.fastcheckout.Transaction.prototype.getGooglemaptypeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setGooglemaptypeList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.addGooglemaptype = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearGooglemaptypeList = function() {
  return this.setGooglemaptypeList([]);
};


/**
 * optional Product Product = 17;
 * @return {?proto.fastcheckout.Product}
 */
proto.fastcheckout.Transaction.prototype.getProduct = function() {
  return /** @type{?proto.fastcheckout.Product} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Product, 17));
};


/**
 * @param {?proto.fastcheckout.Product|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setProduct = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearProduct = function() {
  return this.setProduct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasProduct = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string AdditionalData = 18;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getAdditionaldata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setAdditionaldata = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional Metadata Metadata = 19;
 * @return {?proto.fastcheckout.Metadata}
 */
proto.fastcheckout.Transaction.prototype.getMetadata = function() {
  return /** @type{?proto.fastcheckout.Metadata} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Metadata, 19));
};


/**
 * @param {?proto.fastcheckout.Metadata|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string Category = 20;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional EcommerceData EcommerceData = 21;
 * @return {?proto.fastcheckout.EcommerceData}
 */
proto.fastcheckout.Transaction.prototype.getEcommercedata = function() {
  return /** @type{?proto.fastcheckout.EcommerceData} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.EcommerceData, 21));
};


/**
 * @param {?proto.fastcheckout.EcommerceData|undefined} value
 * @return {!proto.fastcheckout.Transaction} returns this
*/
proto.fastcheckout.Transaction.prototype.setEcommercedata = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.clearEcommercedata = function() {
  return this.setEcommercedata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Transaction.prototype.hasEcommercedata = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string Error = 22;
 * @return {string}
 */
proto.fastcheckout.Transaction.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int32 Sequence = 23;
 * @return {number}
 */
proto.fastcheckout.Transaction.prototype.getSequence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.Transaction} returns this
 */
proto.fastcheckout.Transaction.prototype.setSequence = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Loan.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Loan.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Loan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Loan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Loan.toObject = function(includeInstance, msg) {
  var f, obj = {
    loanid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loannumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
    loantype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    termofloan: jspb.Message.getFieldWithDefault(msg, 4, ""),
    opendate: (f = msg.getOpendate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    duedate: (f = msg.getDuedate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    nextratechangedate: (f = msg.getNextratechangedate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    interest: (f = msg.getInterest()) && proto.fastcheckout.Interest.toObject(includeInstance, f),
    originalprincipalamount: (f = msg.getOriginalprincipalamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    outstandingprincipalamount: (f = msg.getOutstandingprincipalamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    unpaidinstalment: (f = msg.getUnpaidinstalment()) && proto.fastcheckout.UnpaidInstalment.toObject(includeInstance, f),
    remainingterm: jspb.Message.getFieldWithDefault(msg, 12, ""),
    instalmentsList: jspb.Message.toObjectList(msg.getInstalmentsList(),
    proto.fastcheckout.Instalment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Loan}
 */
proto.fastcheckout.Loan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Loan;
  return proto.fastcheckout.Loan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Loan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Loan}
 */
proto.fastcheckout.Loan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoanid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoannumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoantype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTermofloan(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpendate(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDuedate(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextratechangedate(value);
      break;
    case 8:
      var value = new proto.fastcheckout.Interest;
      reader.readMessage(value,proto.fastcheckout.Interest.deserializeBinaryFromReader);
      msg.setInterest(value);
      break;
    case 9:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setOriginalprincipalamount(value);
      break;
    case 10:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setOutstandingprincipalamount(value);
      break;
    case 11:
      var value = new proto.fastcheckout.UnpaidInstalment;
      reader.readMessage(value,proto.fastcheckout.UnpaidInstalment.deserializeBinaryFromReader);
      msg.setUnpaidinstalment(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemainingterm(value);
      break;
    case 13:
      var value = new proto.fastcheckout.Instalment;
      reader.readMessage(value,proto.fastcheckout.Instalment.deserializeBinaryFromReader);
      msg.addInstalments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Loan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Loan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Loan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Loan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoanid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoannumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLoantype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTermofloan();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOpendate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDuedate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNextratechangedate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getInterest();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.fastcheckout.Interest.serializeBinaryToWriter
    );
  }
  f = message.getOriginalprincipalamount();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getOutstandingprincipalamount();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getUnpaidinstalment();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fastcheckout.UnpaidInstalment.serializeBinaryToWriter
    );
  }
  f = message.getRemainingterm();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getInstalmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.fastcheckout.Instalment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string LoanID = 1;
 * @return {string}
 */
proto.fastcheckout.Loan.prototype.getLoanid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.setLoanid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string LoanNumber = 2;
 * @return {string}
 */
proto.fastcheckout.Loan.prototype.getLoannumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.setLoannumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string LoanType = 3;
 * @return {string}
 */
proto.fastcheckout.Loan.prototype.getLoantype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.setLoantype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TermOfLoan = 4;
 * @return {string}
 */
proto.fastcheckout.Loan.prototype.getTermofloan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.setTermofloan = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp OpenDate = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Loan.prototype.getOpendate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setOpendate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearOpendate = function() {
  return this.setOpendate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasOpendate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp DueDate = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Loan.prototype.getDuedate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setDuedate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearDuedate = function() {
  return this.setDuedate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasDuedate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp NextRateChangeDate = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Loan.prototype.getNextratechangedate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setNextratechangedate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearNextratechangedate = function() {
  return this.setNextratechangedate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasNextratechangedate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Interest Interest = 8;
 * @return {?proto.fastcheckout.Interest}
 */
proto.fastcheckout.Loan.prototype.getInterest = function() {
  return /** @type{?proto.fastcheckout.Interest} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Interest, 8));
};


/**
 * @param {?proto.fastcheckout.Interest|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setInterest = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearInterest = function() {
  return this.setInterest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasInterest = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Amount OriginalPrincipalAmount = 9;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Loan.prototype.getOriginalprincipalamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 9));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setOriginalprincipalamount = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearOriginalprincipalamount = function() {
  return this.setOriginalprincipalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasOriginalprincipalamount = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Amount OutstandingPrincipalAmount = 10;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Loan.prototype.getOutstandingprincipalamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 10));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setOutstandingprincipalamount = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearOutstandingprincipalamount = function() {
  return this.setOutstandingprincipalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasOutstandingprincipalamount = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional UnpaidInstalment UnpaidInstalment = 11;
 * @return {?proto.fastcheckout.UnpaidInstalment}
 */
proto.fastcheckout.Loan.prototype.getUnpaidinstalment = function() {
  return /** @type{?proto.fastcheckout.UnpaidInstalment} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.UnpaidInstalment, 11));
};


/**
 * @param {?proto.fastcheckout.UnpaidInstalment|undefined} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setUnpaidinstalment = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearUnpaidinstalment = function() {
  return this.setUnpaidinstalment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Loan.prototype.hasUnpaidinstalment = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string RemainingTerm = 12;
 * @return {string}
 */
proto.fastcheckout.Loan.prototype.getRemainingterm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.setRemainingterm = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated Instalment Instalments = 13;
 * @return {!Array<!proto.fastcheckout.Instalment>}
 */
proto.fastcheckout.Loan.prototype.getInstalmentsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Instalment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Instalment, 13));
};


/**
 * @param {!Array<!proto.fastcheckout.Instalment>} value
 * @return {!proto.fastcheckout.Loan} returns this
*/
proto.fastcheckout.Loan.prototype.setInstalmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.fastcheckout.Instalment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Instalment}
 */
proto.fastcheckout.Loan.prototype.addInstalments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.fastcheckout.Instalment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Loan} returns this
 */
proto.fastcheckout.Loan.prototype.clearInstalmentsList = function() {
  return this.setInstalmentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Instalment.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Instalment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Instalment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Instalment.toObject = function(includeInstance, msg) {
  var f, obj = {
    instalmentid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    paymentdate: (f = msg.getPaymentdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    totalpaidamount: (f = msg.getTotalpaidamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    principalamount: (f = msg.getPrincipalamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    interestamount: (f = msg.getInterestamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    outstandingprincipalamount: (f = msg.getOutstandingprincipalamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Instalment}
 */
proto.fastcheckout.Instalment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Instalment;
  return proto.fastcheckout.Instalment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Instalment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Instalment}
 */
proto.fastcheckout.Instalment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstalmentid(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPaymentdate(value);
      break;
    case 4:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setTotalpaidamount(value);
      break;
    case 5:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setPrincipalamount(value);
      break;
    case 6:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setInterestamount(value);
      break;
    case 7:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setOutstandingprincipalamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Instalment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Instalment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Instalment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Instalment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstalmentid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPaymentdate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTotalpaidamount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getPrincipalamount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getInterestamount();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getOutstandingprincipalamount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
};


/**
 * optional string InstalmentID = 1;
 * @return {string}
 */
proto.fastcheckout.Instalment.prototype.getInstalmentid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.setInstalmentid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp Date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Instalment.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp PaymentDate = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Instalment.prototype.getPaymentdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setPaymentdate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearPaymentdate = function() {
  return this.setPaymentdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasPaymentdate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Amount TotalPaidAmount = 4;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Instalment.prototype.getTotalpaidamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 4));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setTotalpaidamount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearTotalpaidamount = function() {
  return this.setTotalpaidamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasTotalpaidamount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Amount PrincipalAmount = 5;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Instalment.prototype.getPrincipalamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 5));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setPrincipalamount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearPrincipalamount = function() {
  return this.setPrincipalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasPrincipalamount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Amount InterestAmount = 6;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Instalment.prototype.getInterestamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 6));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setInterestamount = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearInterestamount = function() {
  return this.setInterestamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasInterestamount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Amount OutstandingPrincipalAmount = 7;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Instalment.prototype.getOutstandingprincipalamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 7));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Instalment} returns this
*/
proto.fastcheckout.Instalment.prototype.setOutstandingprincipalamount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Instalment} returns this
 */
proto.fastcheckout.Instalment.prototype.clearOutstandingprincipalamount = function() {
  return this.setOutstandingprincipalamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Instalment.prototype.hasOutstandingprincipalamount = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.UnpaidInstalment.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.UnpaidInstalment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.UnpaidInstalment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.UnpaidInstalment.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    amount: (f = msg.getAmount()) && proto.fastcheckout.Amount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.UnpaidInstalment}
 */
proto.fastcheckout.UnpaidInstalment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.UnpaidInstalment;
  return proto.fastcheckout.UnpaidInstalment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.UnpaidInstalment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.UnpaidInstalment}
 */
proto.fastcheckout.UnpaidInstalment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.UnpaidInstalment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.UnpaidInstalment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.UnpaidInstalment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.UnpaidInstalment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp Date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.UnpaidInstalment.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.UnpaidInstalment} returns this
*/
proto.fastcheckout.UnpaidInstalment.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.UnpaidInstalment} returns this
 */
proto.fastcheckout.UnpaidInstalment.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.UnpaidInstalment.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Amount Amount = 2;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.UnpaidInstalment.prototype.getAmount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 2));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.UnpaidInstalment} returns this
*/
proto.fastcheckout.UnpaidInstalment.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.UnpaidInstalment} returns this
 */
proto.fastcheckout.UnpaidInstalment.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.UnpaidInstalment.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Interest.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Interest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Interest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Interest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rate: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Interest}
 */
proto.fastcheckout.Interest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Interest;
  return proto.fastcheckout.Interest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Interest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Interest}
 */
proto.fastcheckout.Interest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.InterestType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Interest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Interest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Interest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Interest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional InterestType Type = 1;
 * @return {!proto.fastcheckout.InterestType}
 */
proto.fastcheckout.Interest.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.InterestType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.InterestType} value
 * @return {!proto.fastcheckout.Interest} returns this
 */
proto.fastcheckout.Interest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Rate = 2;
 * @return {string}
 */
proto.fastcheckout.Interest.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Interest} returns this
 */
proto.fastcheckout.Interest.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.EcommerceAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.EcommerceAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.EcommerceAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.EcommerceAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    receivername: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: jspb.Message.getFieldWithDefault(msg, 3, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.EcommerceAddress}
 */
proto.fastcheckout.EcommerceAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.EcommerceAddress;
  return proto.fastcheckout.EcommerceAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.EcommerceAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.EcommerceAddress}
 */
proto.fastcheckout.EcommerceAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.EcommerceAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.EcommerceAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.EcommerceAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.EcommerceAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReceivername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string AddressName = 1;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getAddressname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setAddressname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ReceiverName = 2;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getReceivername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setReceivername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Address = 3;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PostalCode = 4;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Phone = 5;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Country = 6;
 * @return {string}
 */
proto.fastcheckout.EcommerceAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.EcommerceAddress} returns this
 */
proto.fastcheckout.EcommerceAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Product.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Product.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Product.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    merchant: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Product}
 */
proto.fastcheckout.Product.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Product;
  return proto.fastcheckout.Product.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Product}
 */
proto.fastcheckout.Product.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchant(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Product.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Product.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Product.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMerchant();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.fastcheckout.Product.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Product} returns this
 */
proto.fastcheckout.Product.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Merchant = 2;
 * @return {string}
 */
proto.fastcheckout.Product.prototype.getMerchant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Product} returns this
 */
proto.fastcheckout.Product.prototype.setMerchant = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Category = 3;
 * @return {string}
 */
proto.fastcheckout.Product.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Product} returns this
 */
proto.fastcheckout.Product.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Location.repeatedFields_ = [3,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
    formattedaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    visitcount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    visitdatesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    latitude: jspb.Message.getFieldWithDefault(msg, 4, ""),
    longitude: jspb.Message.getFieldWithDefault(msg, 5, ""),
    label: jspb.Message.getFieldWithDefault(msg, 6, ""),
    addressid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    placeid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    addressinfo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    landmark: jspb.Message.getFieldWithDefault(msg, 10, ""),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    typesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    postcode: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Location}
 */
proto.fastcheckout.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Location;
  return proto.fastcheckout.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Location}
 */
proto.fastcheckout.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedaddress(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVisitcount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addVisitdates(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLatitude(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongitude(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressinfo(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLandmark(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addTypes(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormattedaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVisitcount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getVisitdatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getLatitude();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLongitude();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAddressid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPlaceid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressinfo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLandmark();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getPostcode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string FormattedAddress = 1;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getFormattedaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setFormattedaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 VisitCount = 2;
 * @return {number}
 */
proto.fastcheckout.Location.prototype.getVisitcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setVisitcount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string VisitDates = 3;
 * @return {!Array<string>}
 */
proto.fastcheckout.Location.prototype.getVisitdatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setVisitdatesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.addVisitdates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.clearVisitdatesList = function() {
  return this.setVisitdatesList([]);
};


/**
 * optional string Latitude = 4;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getLatitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Longitude = 5;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getLongitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Label = 6;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string AddressID = 7;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getAddressid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setAddressid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string PlaceID = 8;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getPlaceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setPlaceid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AddressInfo = 9;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getAddressinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setAddressinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Landmark = 10;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getLandmark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setLandmark = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp CreatedAt = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Location.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Location} returns this
*/
proto.fastcheckout.Location.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Location.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated string Types = 12;
 * @return {!Array<string>}
 */
proto.fastcheckout.Location.prototype.getTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setTypesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.addTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.clearTypesList = function() {
  return this.setTypesList([]);
};


/**
 * optional string PostCode = 13;
 * @return {string}
 */
proto.fastcheckout.Location.prototype.getPostcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Location} returns this
 */
proto.fastcheckout.Location.prototype.setPostcode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.GopayCustomer.repeatedFields_ = [16,17,18,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.GopayCustomer.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.GopayCustomer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.GopayCustomer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GopayCustomer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    number: jspb.Message.getFieldWithDefault(msg, 5, ""),
    signedupcountry: jspb.Message.getFieldWithDefault(msg, 6, ""),
    countrycode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    emailverified: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    locale: jspb.Message.getFieldWithDefault(msg, 9, ""),
    localeselectiontype: jspb.Message.getFieldWithDefault(msg, 10, ""),
    facebookconnected: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    chatid: jspb.Message.getFieldWithDefault(msg, 12, ""),
    chattoken: jspb.Message.getFieldWithDefault(msg, 13, ""),
    createdat: jspb.Message.getFieldWithDefault(msg, 14, ""),
    locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    proto.fastcheckout.Location.toObject, includeInstance),
    labelledlocationsList: jspb.Message.toObjectList(msg.getLabelledlocationsList(),
    proto.fastcheckout.Location.toObject, includeInstance),
    savedlocationsList: jspb.Message.toObjectList(msg.getSavedlocationsList(),
    proto.fastcheckout.Location.toObject, includeInstance),
    addresstaglocationsList: jspb.Message.toObjectList(msg.getAddresstaglocationsList(),
    brank_as_gunk_b$enterprise_v1_addresstag_all_pb.AddressTag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.GopayCustomer}
 */
proto.fastcheckout.GopayCustomer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.GopayCustomer;
  return proto.fastcheckout.GopayCustomer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.GopayCustomer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.GopayCustomer}
 */
proto.fastcheckout.GopayCustomer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedupcountry(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailverified(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocaleselectiontype(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFacebookconnected(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setChattoken(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 16:
      var value = new proto.fastcheckout.Location;
      reader.readMessage(value,proto.fastcheckout.Location.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    case 17:
      var value = new proto.fastcheckout.Location;
      reader.readMessage(value,proto.fastcheckout.Location.deserializeBinaryFromReader);
      msg.addLabelledlocations(value);
      break;
    case 18:
      var value = new proto.fastcheckout.Location;
      reader.readMessage(value,proto.fastcheckout.Location.deserializeBinaryFromReader);
      msg.addSavedlocations(value);
      break;
    case 19:
      var value = new brank_as_gunk_b$enterprise_v1_addresstag_all_pb.AddressTag;
      reader.readMessage(value,brank_as_gunk_b$enterprise_v1_addresstag_all_pb.AddressTag.deserializeBinaryFromReader);
      msg.addAddresstaglocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.GopayCustomer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.GopayCustomer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.GopayCustomer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GopayCustomer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSignedupcountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmailverified();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLocaleselectiontype();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFacebookconnected();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getChatid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getChattoken();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCreatedat();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.fastcheckout.Location.serializeBinaryToWriter
    );
  }
  f = message.getLabelledlocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.fastcheckout.Location.serializeBinaryToWriter
    );
  }
  f = message.getSavedlocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.fastcheckout.Location.serializeBinaryToWriter
    );
  }
  f = message.getAddresstaglocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      brank_as_gunk_b$enterprise_v1_addresstag_all_pb.AddressTag.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Phone = 4;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Number = 5;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string SignedUpCountry = 6;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getSignedupcountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setSignedupcountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CountryCode = 7;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool EmailVerified = 8;
 * @return {boolean}
 */
proto.fastcheckout.GopayCustomer.prototype.getEmailverified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setEmailverified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string Locale = 9;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string LocaleSelectionType = 10;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getLocaleselectiontype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setLocaleselectiontype = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool FacebookConnected = 11;
 * @return {boolean}
 */
proto.fastcheckout.GopayCustomer.prototype.getFacebookconnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setFacebookconnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string ChatID = 12;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getChatid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setChatid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ChatToken = 13;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getChattoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setChattoken = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string CreatedAt = 14;
 * @return {string}
 */
proto.fastcheckout.GopayCustomer.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated Location Locations = 16;
 * @return {!Array<!proto.fastcheckout.Location>}
 */
proto.fastcheckout.GopayCustomer.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Location>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Location, 16));
};


/**
 * @param {!Array<!proto.fastcheckout.Location>} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
*/
proto.fastcheckout.GopayCustomer.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.fastcheckout.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Location}
 */
proto.fastcheckout.GopayCustomer.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.fastcheckout.Location, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


/**
 * repeated Location LabelledLocations = 17;
 * @return {!Array<!proto.fastcheckout.Location>}
 */
proto.fastcheckout.GopayCustomer.prototype.getLabelledlocationsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Location>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Location, 17));
};


/**
 * @param {!Array<!proto.fastcheckout.Location>} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
*/
proto.fastcheckout.GopayCustomer.prototype.setLabelledlocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.fastcheckout.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Location}
 */
proto.fastcheckout.GopayCustomer.prototype.addLabelledlocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.fastcheckout.Location, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.clearLabelledlocationsList = function() {
  return this.setLabelledlocationsList([]);
};


/**
 * repeated Location SavedLocations = 18;
 * @return {!Array<!proto.fastcheckout.Location>}
 */
proto.fastcheckout.GopayCustomer.prototype.getSavedlocationsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Location>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Location, 18));
};


/**
 * @param {!Array<!proto.fastcheckout.Location>} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
*/
proto.fastcheckout.GopayCustomer.prototype.setSavedlocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.fastcheckout.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Location}
 */
proto.fastcheckout.GopayCustomer.prototype.addSavedlocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.fastcheckout.Location, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.clearSavedlocationsList = function() {
  return this.setSavedlocationsList([]);
};


/**
 * repeated addresstag.AddressTag AddressTagLocations = 19;
 * @return {!Array<!proto.addresstag.AddressTag>}
 */
proto.fastcheckout.GopayCustomer.prototype.getAddresstaglocationsList = function() {
  return /** @type{!Array<!proto.addresstag.AddressTag>} */ (
    jspb.Message.getRepeatedWrapperField(this, brank_as_gunk_b$enterprise_v1_addresstag_all_pb.AddressTag, 19));
};


/**
 * @param {!Array<!proto.addresstag.AddressTag>} value
 * @return {!proto.fastcheckout.GopayCustomer} returns this
*/
proto.fastcheckout.GopayCustomer.prototype.setAddresstaglocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.addresstag.AddressTag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.addresstag.AddressTag}
 */
proto.fastcheckout.GopayCustomer.prototype.addAddresstaglocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.addresstag.AddressTag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.GopayCustomer} returns this
 */
proto.fastcheckout.GopayCustomer.prototype.clearAddresstaglocationsList = function() {
  return this.setAddresstaglocationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.GCashAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.GCashAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.GCashAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GCashAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    city: jspb.Message.getFieldWithDefault(msg, 1, ""),
    cityid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    country: jspb.Message.getFieldWithDefault(msg, 3, ""),
    countryid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    province: jspb.Message.getFieldWithDefault(msg, 5, ""),
    provinceid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.GCashAddress}
 */
proto.fastcheckout.GCashAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.GCashAddress;
  return proto.fastcheckout.GCashAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.GCashAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.GCashAddress}
 */
proto.fastcheckout.GCashAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvinceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.GCashAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.GCashAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.GCashAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GCashAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCityid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountryid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProvinceid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string City = 1;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string CityID = 2;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getCityid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setCityid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Country = 3;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string CountryID = 4;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getCountryid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setCountryid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Province = 5;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ProvinceID = 6;
 * @return {string}
 */
proto.fastcheckout.GCashAddress.prototype.getProvinceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashAddress} returns this
 */
proto.fastcheckout.GCashAddress.prototype.setProvinceid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.GCashCustomer.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.GCashCustomer.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.GCashCustomer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.GCashCustomer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GCashCustomer.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lastname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    nickname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    birthdate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    birthplace: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, ""),
    province: jspb.Message.getFieldWithDefault(msg, 7, ""),
    city: jspb.Message.getFieldWithDefault(msg, 8, ""),
    nationality: jspb.Message.getFieldWithDefault(msg, 9, ""),
    maritalstatus: jspb.Message.getFieldWithDefault(msg, 10, ""),
    email: jspb.Message.getFieldWithDefault(msg, 11, ""),
    currentaddress: (f = msg.getCurrentaddress()) && proto.fastcheckout.GCashAddress.toObject(includeInstance, f),
    parentaddress: (f = msg.getParentaddress()) && proto.fastcheckout.GCashAddress.toObject(includeInstance, f),
    sourceoffundsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    worknature: jspb.Message.getFieldWithDefault(msg, 15, ""),
    nameofcompanybusiness: jspb.Message.getFieldWithDefault(msg, 16, ""),
    crnnumber: jspb.Message.getFieldWithDefault(msg, 17, ""),
    governmentidtype: jspb.Message.getFieldWithDefault(msg, 18, ""),
    governmentidnumber: jspb.Message.getFieldWithDefault(msg, 19, ""),
    nogovernmentidreason: jspb.Message.getFieldWithDefault(msg, 20, ""),
    applicationstatus: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.GCashCustomer}
 */
proto.fastcheckout.GCashCustomer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.GCashCustomer;
  return proto.fastcheckout.GCashCustomer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.GCashCustomer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.GCashCustomer}
 */
proto.fastcheckout.GCashCustomer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBirthdate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBirthplace(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNationality(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaritalstatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 12:
      var value = new proto.fastcheckout.GCashAddress;
      reader.readMessage(value,proto.fastcheckout.GCashAddress.deserializeBinaryFromReader);
      msg.setCurrentaddress(value);
      break;
    case 13:
      var value = new proto.fastcheckout.GCashAddress;
      reader.readMessage(value,proto.fastcheckout.GCashAddress.deserializeBinaryFromReader);
      msg.setParentaddress(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addSourceoffunds(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorknature(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setNameofcompanybusiness(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCrnnumber(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setGovernmentidtype(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setGovernmentidnumber(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setNogovernmentidreason(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.GCashCustomer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.GCashCustomer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.GCashCustomer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.GCashCustomer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBirthdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBirthplace();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNationality();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMaritalstatus();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCurrentaddress();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.fastcheckout.GCashAddress.serializeBinaryToWriter
    );
  }
  f = message.getParentaddress();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.fastcheckout.GCashAddress.serializeBinaryToWriter
    );
  }
  f = message.getSourceoffundsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getWorknature();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getNameofcompanybusiness();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCrnnumber();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getGovernmentidtype();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getGovernmentidnumber();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getNogovernmentidreason();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getApplicationstatus();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string FirstName = 1;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getFirstname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setFirstname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string LastName = 2;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getLastname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setLastname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string NickName = 3;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string BirthDate = 4;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getBirthdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setBirthdate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BirthPlace = 5;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getBirthplace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setBirthplace = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Country = 6;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Province = 7;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string City = 8;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Nationality = 9;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getNationality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setNationality = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string MaritalStatus = 10;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getMaritalstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setMaritalstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Email = 11;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional GCashAddress CurrentAddress = 12;
 * @return {?proto.fastcheckout.GCashAddress}
 */
proto.fastcheckout.GCashCustomer.prototype.getCurrentaddress = function() {
  return /** @type{?proto.fastcheckout.GCashAddress} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.GCashAddress, 12));
};


/**
 * @param {?proto.fastcheckout.GCashAddress|undefined} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
*/
proto.fastcheckout.GCashCustomer.prototype.setCurrentaddress = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.clearCurrentaddress = function() {
  return this.setCurrentaddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.GCashCustomer.prototype.hasCurrentaddress = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional GCashAddress ParentAddress = 13;
 * @return {?proto.fastcheckout.GCashAddress}
 */
proto.fastcheckout.GCashCustomer.prototype.getParentaddress = function() {
  return /** @type{?proto.fastcheckout.GCashAddress} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.GCashAddress, 13));
};


/**
 * @param {?proto.fastcheckout.GCashAddress|undefined} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
*/
proto.fastcheckout.GCashCustomer.prototype.setParentaddress = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.clearParentaddress = function() {
  return this.setParentaddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.GCashCustomer.prototype.hasParentaddress = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated string SourceOfFunds = 14;
 * @return {!Array<string>}
 */
proto.fastcheckout.GCashCustomer.prototype.getSourceoffundsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setSourceoffundsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.addSourceoffunds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.clearSourceoffundsList = function() {
  return this.setSourceoffundsList([]);
};


/**
 * optional string WorkNature = 15;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getWorknature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setWorknature = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string NameOfCompanyBusiness = 16;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getNameofcompanybusiness = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setNameofcompanybusiness = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string CRNNumber = 17;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getCrnnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setCrnnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string GovernmentIDType = 18;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getGovernmentidtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setGovernmentidtype = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string GovernmentIDNumber = 19;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getGovernmentidnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setGovernmentidnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string NoGovernmentIDReason = 20;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getNogovernmentidreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setNogovernmentidreason = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string ApplicationStatus = 21;
 * @return {string}
 */
proto.fastcheckout.GCashCustomer.prototype.getApplicationstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.GCashCustomer} returns this
 */
proto.fastcheckout.GCashCustomer.prototype.setApplicationstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.AccountMetadata.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.AccountMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.AccountMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.AccountMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    receivername: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: jspb.Message.getFieldWithDefault(msg, 3, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, ""),
    addressvisitcount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    addressvisitdatesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    addresslatitude: jspb.Message.getFieldWithDefault(msg, 9, ""),
    addresslongitude: jspb.Message.getFieldWithDefault(msg, 10, ""),
    gopaycustomer: (f = msg.getGopaycustomer()) && proto.fastcheckout.GopayCustomer.toObject(includeInstance, f),
    gcashcustomer: (f = msg.getGcashcustomer()) && proto.fastcheckout.GCashCustomer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.AccountMetadata}
 */
proto.fastcheckout.AccountMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.AccountMetadata;
  return proto.fastcheckout.AccountMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.AccountMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.AccountMetadata}
 */
proto.fastcheckout.AccountMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceivername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddressvisitcount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddressvisitdates(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddresslatitude(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddresslongitude(value);
      break;
    case 11:
      var value = new proto.fastcheckout.GopayCustomer;
      reader.readMessage(value,proto.fastcheckout.GopayCustomer.deserializeBinaryFromReader);
      msg.setGopaycustomer(value);
      break;
    case 12:
      var value = new proto.fastcheckout.GCashCustomer;
      reader.readMessage(value,proto.fastcheckout.GCashCustomer.deserializeBinaryFromReader);
      msg.setGcashcustomer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.AccountMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.AccountMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.AccountMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReceivername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAddressvisitcount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getAddressvisitdatesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getAddresslatitude();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddresslongitude();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getGopaycustomer();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fastcheckout.GopayCustomer.serializeBinaryToWriter
    );
  }
  f = message.getGcashcustomer();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.fastcheckout.GCashCustomer.serializeBinaryToWriter
    );
  }
};


/**
 * optional string AddressName = 1;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddressname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddressname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ReceiverName = 2;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getReceivername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setReceivername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Address = 3;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PostalCode = 4;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Phone = 5;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Country = 6;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 AddressVisitCount = 7;
 * @return {number}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddressvisitcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddressvisitcount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated string AddressVisitDates = 8;
 * @return {!Array<string>}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddressvisitdatesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddressvisitdatesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.addAddressvisitdates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.clearAddressvisitdatesList = function() {
  return this.setAddressvisitdatesList([]);
};


/**
 * optional string AddressLatitude = 9;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddresslatitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddresslatitude = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AddressLongitude = 10;
 * @return {string}
 */
proto.fastcheckout.AccountMetadata.prototype.getAddresslongitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.setAddresslongitude = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional GopayCustomer GopayCustomer = 11;
 * @return {?proto.fastcheckout.GopayCustomer}
 */
proto.fastcheckout.AccountMetadata.prototype.getGopaycustomer = function() {
  return /** @type{?proto.fastcheckout.GopayCustomer} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.GopayCustomer, 11));
};


/**
 * @param {?proto.fastcheckout.GopayCustomer|undefined} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
*/
proto.fastcheckout.AccountMetadata.prototype.setGopaycustomer = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.clearGopaycustomer = function() {
  return this.setGopaycustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.AccountMetadata.prototype.hasGopaycustomer = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional GCashCustomer GCashCustomer = 12;
 * @return {?proto.fastcheckout.GCashCustomer}
 */
proto.fastcheckout.AccountMetadata.prototype.getGcashcustomer = function() {
  return /** @type{?proto.fastcheckout.GCashCustomer} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.GCashCustomer, 12));
};


/**
 * @param {?proto.fastcheckout.GCashCustomer|undefined} value
 * @return {!proto.fastcheckout.AccountMetadata} returns this
*/
proto.fastcheckout.AccountMetadata.prototype.setGcashcustomer = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.AccountMetadata} returns this
 */
proto.fastcheckout.AccountMetadata.prototype.clearGcashcustomer = function() {
  return this.setGcashcustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.AccountMetadata.prototype.hasGcashcustomer = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Metadata.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Metadata.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Metadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Metadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Metadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    invoice: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalorderprice: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.fastcheckout.ProductMetadata.toObject, includeInstance),
    orderid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ordersList: jspb.Message.toObjectList(msg.getOrdersList(),
    proto.fastcheckout.Order.toObject, includeInstance),
    origin: (f = msg.getOrigin()) && proto.fastcheckout.Location.toObject(includeInstance, f),
    destination: (f = msg.getDestination()) && proto.fastcheckout.Location.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Metadata}
 */
proto.fastcheckout.Metadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Metadata;
  return proto.fastcheckout.Metadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Metadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Metadata}
 */
proto.fastcheckout.Metadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoice(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalorderprice(value);
      break;
    case 3:
      var value = new proto.fastcheckout.ProductMetadata;
      reader.readMessage(value,proto.fastcheckout.ProductMetadata.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 5:
      var value = new proto.fastcheckout.Order;
      reader.readMessage(value,proto.fastcheckout.Order.deserializeBinaryFromReader);
      msg.addOrders(value);
      break;
    case 6:
      var value = new proto.fastcheckout.Location;
      reader.readMessage(value,proto.fastcheckout.Location.deserializeBinaryFromReader);
      msg.setOrigin(value);
      break;
    case 7:
      var value = new proto.fastcheckout.Location;
      reader.readMessage(value,proto.fastcheckout.Location.deserializeBinaryFromReader);
      msg.setDestination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Metadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Metadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Metadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Metadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoice();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalorderprice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fastcheckout.ProductMetadata.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOrdersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.fastcheckout.Order.serializeBinaryToWriter
    );
  }
  f = message.getOrigin();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.fastcheckout.Location.serializeBinaryToWriter
    );
  }
  f = message.getDestination();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.fastcheckout.Location.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Invoice = 1;
 * @return {string}
 */
proto.fastcheckout.Metadata.prototype.getInvoice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.setInvoice = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string TotalOrderPrice = 2;
 * @return {string}
 */
proto.fastcheckout.Metadata.prototype.getTotalorderprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.setTotalorderprice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ProductMetadata Products = 3;
 * @return {!Array<!proto.fastcheckout.ProductMetadata>}
 */
proto.fastcheckout.Metadata.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.fastcheckout.ProductMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.ProductMetadata, 3));
};


/**
 * @param {!Array<!proto.fastcheckout.ProductMetadata>} value
 * @return {!proto.fastcheckout.Metadata} returns this
*/
proto.fastcheckout.Metadata.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fastcheckout.ProductMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.ProductMetadata}
 */
proto.fastcheckout.Metadata.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fastcheckout.ProductMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};


/**
 * optional string OrderID = 4;
 * @return {string}
 */
proto.fastcheckout.Metadata.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.setOrderid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated Order Orders = 5;
 * @return {!Array<!proto.fastcheckout.Order>}
 */
proto.fastcheckout.Metadata.prototype.getOrdersList = function() {
  return /** @type{!Array<!proto.fastcheckout.Order>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Order, 5));
};


/**
 * @param {!Array<!proto.fastcheckout.Order>} value
 * @return {!proto.fastcheckout.Metadata} returns this
*/
proto.fastcheckout.Metadata.prototype.setOrdersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.fastcheckout.Order=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Order}
 */
proto.fastcheckout.Metadata.prototype.addOrders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.fastcheckout.Order, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.clearOrdersList = function() {
  return this.setOrdersList([]);
};


/**
 * optional Location Origin = 6;
 * @return {?proto.fastcheckout.Location}
 */
proto.fastcheckout.Metadata.prototype.getOrigin = function() {
  return /** @type{?proto.fastcheckout.Location} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Location, 6));
};


/**
 * @param {?proto.fastcheckout.Location|undefined} value
 * @return {!proto.fastcheckout.Metadata} returns this
*/
proto.fastcheckout.Metadata.prototype.setOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.clearOrigin = function() {
  return this.setOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Metadata.prototype.hasOrigin = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Location Destination = 7;
 * @return {?proto.fastcheckout.Location}
 */
proto.fastcheckout.Metadata.prototype.getDestination = function() {
  return /** @type{?proto.fastcheckout.Location} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Location, 7));
};


/**
 * @param {?proto.fastcheckout.Location|undefined} value
 * @return {!proto.fastcheckout.Metadata} returns this
*/
proto.fastcheckout.Metadata.prototype.setDestination = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Metadata} returns this
 */
proto.fastcheckout.Metadata.prototype.clearDestination = function() {
  return this.setDestination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Metadata.prototype.hasDestination = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.ProductMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.ProductMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.ProductMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.ProductMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    price: jspb.Message.getFieldWithDefault(msg, 2, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalsubprice: jspb.Message.getFieldWithDefault(msg, 4, ""),
    merchant: jspb.Message.getFieldWithDefault(msg, 5, ""),
    category: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.ProductMetadata}
 */
proto.fastcheckout.ProductMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.ProductMetadata;
  return proto.fastcheckout.ProductMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.ProductMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.ProductMetadata}
 */
proto.fastcheckout.ProductMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalsubprice(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchant(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.ProductMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.ProductMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.ProductMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.ProductMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalsubprice();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMerchant();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.fastcheckout.ProductMetadata.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Price = 2;
 * @return {string}
 */
proto.fastcheckout.ProductMetadata.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 Quantity = 3;
 * @return {number}
 */
proto.fastcheckout.ProductMetadata.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string TotalSubPrice = 4;
 * @return {string}
 */
proto.fastcheckout.ProductMetadata.prototype.getTotalsubprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setTotalsubprice = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Merchant = 5;
 * @return {string}
 */
proto.fastcheckout.ProductMetadata.prototype.getMerchant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setMerchant = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Category = 6;
 * @return {string}
 */
proto.fastcheckout.ProductMetadata.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.ProductMetadata} returns this
 */
proto.fastcheckout.ProductMetadata.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.Statement.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Statement.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Statement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Statement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Statement.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    statementid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    startdate: (f = msg.getStartdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    enddate: (f = msg.getEnddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    accountstatementsList: jspb.Message.toObjectList(msg.getAccountstatementsList(),
    proto.fastcheckout.AccountStatement.toObject, includeInstance),
    error: jspb.Message.getFieldWithDefault(msg, 8, ""),
    request: (f = msg.getRequest()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    create: (f = msg.getCreate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    accountpdfsMap: (f = msg.getAccountpdfsMap()) ? f.toObject(includeInstance, undefined) : [],
    externalid: jspb.Message.getFieldWithDefault(msg, 12, ""),
    channel: jspb.Message.getFieldWithDefault(msg, 13, ""),
    country: jspb.Message.getFieldWithDefault(msg, 14, ""),
    isidp: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    substatus: jspb.Message.getFieldWithDefault(msg, 16, 0),
    update: (f = msg.getUpdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isnotificationsuccess: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    siteresponse: jspb.Message.getFieldWithDefault(msg, 19, ""),
    challenge: (f = msg.getChallenge()) && proto.fastcheckout.Challenge.toObject(includeInstance, f),
    shortcode: jspb.Message.getFieldWithDefault(msg, 21, ""),
    consentgranted: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    orgid: jspb.Message.getFieldWithDefault(msg, 23, ""),
    userinitiatedat: (f = msg.getUserinitiatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    systeminitiatedat: (f = msg.getSysteminitiatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    details: jspb.Message.getFieldWithDefault(msg, 26, ""),
    istask: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
    login: jspb.Message.getFieldWithDefault(msg, 28, ""),
    finished: (f = msg.getFinished()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    income: (f = msg.getIncome()) && brank_as_gunk_b$enterprise_v1_income_all_pb.Income.toObject(includeInstance, f),
    statusdesc: jspb.Message.getFieldWithDefault(msg, 31, ""),
    statuscode: jspb.Message.getFieldWithDefault(msg, 32, ""),
    localtime: (f = msg.getLocaltime()) && proto.fastcheckout.LocalTime.toObject(includeInstance, f),
    riskinsight: jspb.Message.getBooleanFieldWithDefault(msg, 34, false),
    includebalance: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    accountlinkid: jspb.Message.getFieldWithDefault(msg, 36, ""),
    reconciliationid: jspb.Message.getFieldWithDefault(msg, 37, ""),
    customshortcode: jspb.Message.getFieldWithDefault(msg, 38, ""),
    parentstatementid: jspb.Message.getFieldWithDefault(msg, 39, ""),
    isrecon: jspb.Message.getBooleanFieldWithDefault(msg, 40, false),
    accountverification: jspb.Message.getBooleanFieldWithDefault(msg, 41, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Statement}
 */
proto.fastcheckout.Statement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Statement;
  return proto.fastcheckout.Statement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Statement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Statement}
 */
proto.fastcheckout.Statement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.StatementStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartdate(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnddate(value);
      break;
    case 7:
      var value = new proto.fastcheckout.AccountStatement;
      reader.readMessage(value,proto.fastcheckout.AccountStatement.deserializeBinaryFromReader);
      msg.addAccountstatements(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreate(value);
      break;
    case 11:
      var value = msg.getAccountpdfsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readBytes, null, "", "");
         });
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannel(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsidp(value);
      break;
    case 16:
      var value = /** @type {!proto.fastcheckout.StatementSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdate(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsnotificationsuccess(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteresponse(value);
      break;
    case 20:
      var value = new proto.fastcheckout.Challenge;
      reader.readMessage(value,proto.fastcheckout.Challenge.deserializeBinaryFromReader);
      msg.setChallenge(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortcode(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsentgranted(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUserinitiatedat(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSysteminitiatedat(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIstask(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 29:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinished(value);
      break;
    case 30:
      var value = new brank_as_gunk_b$enterprise_v1_income_all_pb.Income;
      reader.readMessage(value,brank_as_gunk_b$enterprise_v1_income_all_pb.Income.deserializeBinaryFromReader);
      msg.setIncome(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdesc(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscode(value);
      break;
    case 33:
      var value = new proto.fastcheckout.LocalTime;
      reader.readMessage(value,proto.fastcheckout.LocalTime.deserializeBinaryFromReader);
      msg.setLocaltime(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRiskinsight(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludebalance(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountlinkid(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setReconciliationid(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomshortcode(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentstatementid(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecon(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccountverification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Statement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Statement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Statement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Statement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStartdate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnddate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountstatementsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fastcheckout.AccountStatement.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountpdfsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeBytes);
  }
  f = message.getExternalid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsidp();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getUpdate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsnotificationsuccess();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getSiteresponse();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getChallenge();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.fastcheckout.Challenge.serializeBinaryToWriter
    );
  }
  f = message.getShortcode();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getConsentgranted();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getUserinitiatedat();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSysteminitiatedat();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getIstask();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getFinished();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIncome();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      brank_as_gunk_b$enterprise_v1_income_all_pb.Income.serializeBinaryToWriter
    );
  }
  f = message.getStatusdesc();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getLocaltime();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.fastcheckout.LocalTime.serializeBinaryToWriter
    );
  }
  f = message.getRiskinsight();
  if (f) {
    writer.writeBool(
      34,
      f
    );
  }
  f = message.getIncludebalance();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getAccountlinkid();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getReconciliationid();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getCustomshortcode();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getParentstatementid();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getIsrecon();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
  f = message.getAccountverification();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
};


/**
 * optional StatementStatus Status = 1;
 * @return {!proto.fastcheckout.StatementStatus}
 */
proto.fastcheckout.Statement.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.StatementStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.StatementStatus} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string StatementID = 2;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BankCode BankCode = 3;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.Statement.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp StartDate = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getStartdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setStartdate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearStartdate = function() {
  return this.setStartdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasStartdate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp EndDate = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getEnddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setEnddate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearEnddate = function() {
  return this.setEnddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasEnddate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated AccountStatement AccountStatements = 7;
 * @return {!Array<!proto.fastcheckout.AccountStatement>}
 */
proto.fastcheckout.Statement.prototype.getAccountstatementsList = function() {
  return /** @type{!Array<!proto.fastcheckout.AccountStatement>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.AccountStatement, 7));
};


/**
 * @param {!Array<!proto.fastcheckout.AccountStatement>} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setAccountstatementsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fastcheckout.AccountStatement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.AccountStatement}
 */
proto.fastcheckout.Statement.prototype.addAccountstatements = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fastcheckout.AccountStatement, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearAccountstatementsList = function() {
  return this.setAccountstatementsList([]);
};


/**
 * optional string Error = 8;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp Request = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getRequest = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp Create = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getCreate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setCreate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearCreate = function() {
  return this.setCreate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasCreate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * map<string, bytes> AccountPdfs = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!(string|Uint8Array)>}
 */
proto.fastcheckout.Statement.prototype.getAccountpdfsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!(string|Uint8Array)>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearAccountpdfsMap = function() {
  this.getAccountpdfsMap().clear();
  return this;};


/**
 * optional string ExternalID = 12;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getExternalid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setExternalid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string Channel = 13;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Country = 14;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool IsIDP = 15;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getIsidp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setIsidp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional StatementSubStatus SubStatus = 16;
 * @return {!proto.fastcheckout.StatementSubStatus}
 */
proto.fastcheckout.Statement.prototype.getSubstatus = function() {
  return /** @type {!proto.fastcheckout.StatementSubStatus} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.fastcheckout.StatementSubStatus} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp Update = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getUpdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearUpdate = function() {
  return this.setUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasUpdate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool IsNotificationSuccess = 18;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getIsnotificationsuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setIsnotificationsuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string SiteResponse = 19;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getSiteresponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setSiteresponse = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional Challenge Challenge = 20;
 * @return {?proto.fastcheckout.Challenge}
 */
proto.fastcheckout.Statement.prototype.getChallenge = function() {
  return /** @type{?proto.fastcheckout.Challenge} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Challenge, 20));
};


/**
 * @param {?proto.fastcheckout.Challenge|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setChallenge = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearChallenge = function() {
  return this.setChallenge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasChallenge = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string ShortCode = 21;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getShortcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setShortcode = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional bool ConsentGranted = 22;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getConsentgranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setConsentgranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional string OrgID = 23;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional google.protobuf.Timestamp UserInitiatedAt = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getUserinitiatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setUserinitiatedat = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearUserinitiatedat = function() {
  return this.setUserinitiatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasUserinitiatedat = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.Timestamp SystemInitiatedAt = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getSysteminitiatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setSysteminitiatedat = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearSysteminitiatedat = function() {
  return this.setSysteminitiatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasSysteminitiatedat = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional string Details = 26;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional bool IsTask = 27;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getIstask = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setIstask = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional string Login = 28;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional google.protobuf.Timestamp Finished = 29;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Statement.prototype.getFinished = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 29));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setFinished = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearFinished = function() {
  return this.setFinished(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasFinished = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional income.Income Income = 30;
 * @return {?proto.income.Income}
 */
proto.fastcheckout.Statement.prototype.getIncome = function() {
  return /** @type{?proto.income.Income} */ (
    jspb.Message.getWrapperField(this, brank_as_gunk_b$enterprise_v1_income_all_pb.Income, 30));
};


/**
 * @param {?proto.income.Income|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setIncome = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearIncome = function() {
  return this.setIncome(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasIncome = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional string StatusDesc = 31;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getStatusdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setStatusdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string StatusCode = 32;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getStatuscode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setStatuscode = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional LocalTime LocalTime = 33;
 * @return {?proto.fastcheckout.LocalTime}
 */
proto.fastcheckout.Statement.prototype.getLocaltime = function() {
  return /** @type{?proto.fastcheckout.LocalTime} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.LocalTime, 33));
};


/**
 * @param {?proto.fastcheckout.LocalTime|undefined} value
 * @return {!proto.fastcheckout.Statement} returns this
*/
proto.fastcheckout.Statement.prototype.setLocaltime = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.clearLocaltime = function() {
  return this.setLocaltime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.hasLocaltime = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional bool RiskInsight = 34;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getRiskinsight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setRiskinsight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 34, value);
};


/**
 * optional bool IncludeBalance = 35;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getIncludebalance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setIncludebalance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional string AccountLinkID = 36;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getAccountlinkid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setAccountlinkid = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string ReconciliationID = 37;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getReconciliationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setReconciliationid = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string CustomShortCode = 38;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getCustomshortcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setCustomshortcode = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string ParentStatementID = 39;
 * @return {string}
 */
proto.fastcheckout.Statement.prototype.getParentstatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setParentstatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional bool IsRecon = 40;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getIsrecon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setIsrecon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};


/**
 * optional bool AccountVerification = 41;
 * @return {boolean}
 */
proto.fastcheckout.Statement.prototype.getAccountverification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Statement} returns this
 */
proto.fastcheckout.Statement.prototype.setAccountverification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.LocalTime.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.LocalTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.LocalTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.LocalTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    startdate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    enddate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    create: jspb.Message.getFieldWithDefault(msg, 3, ""),
    update: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.LocalTime}
 */
proto.fastcheckout.LocalTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.LocalTime;
  return proto.fastcheckout.LocalTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.LocalTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.LocalTime}
 */
proto.fastcheckout.LocalTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnddate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.LocalTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.LocalTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.LocalTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.LocalTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnddate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string StartDate = 1;
 * @return {string}
 */
proto.fastcheckout.LocalTime.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LocalTime} returns this
 */
proto.fastcheckout.LocalTime.prototype.setStartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string EndDate = 2;
 * @return {string}
 */
proto.fastcheckout.LocalTime.prototype.getEnddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LocalTime} returns this
 */
proto.fastcheckout.LocalTime.prototype.setEnddate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Create = 3;
 * @return {string}
 */
proto.fastcheckout.LocalTime.prototype.getCreate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LocalTime} returns this
 */
proto.fastcheckout.LocalTime.prototype.setCreate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Update = 4;
 * @return {string}
 */
proto.fastcheckout.LocalTime.prototype.getUpdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LocalTime} returns this
 */
proto.fastcheckout.LocalTime.prototype.setUpdate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Challenge.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Challenge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Challenge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Challenge.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Challenge}
 */
proto.fastcheckout.Challenge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Challenge;
  return proto.fastcheckout.Challenge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Challenge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Challenge}
 */
proto.fastcheckout.Challenge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.ChallengeType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Challenge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Challenge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Challenge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Challenge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional ChallengeType Type = 1;
 * @return {!proto.fastcheckout.ChallengeType}
 */
proto.fastcheckout.Challenge.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.ChallengeType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.ChallengeType} value
 * @return {!proto.fastcheckout.Challenge} returns this
 */
proto.fastcheckout.Challenge.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.fastcheckout.Challenge.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.fastcheckout.Challenge.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.fastcheckout.Challenge.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fastcheckout.Challenge} returns this
 */
proto.fastcheckout.Challenge.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.AccountStatement.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.AccountStatement.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.AccountStatement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.AccountStatement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountStatement.toObject = function(includeInstance, msg) {
  var f, obj = {
    account: (f = msg.getAccount()) && proto.fastcheckout.Account.toObject(includeInstance, f),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.fastcheckout.Transaction.toObject, includeInstance),
    accountpdfs: msg.getAccountpdfs_asB64(),
    loansList: jspb.Message.toObjectList(msg.getLoansList(),
    proto.fastcheckout.Loan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.AccountStatement}
 */
proto.fastcheckout.AccountStatement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.AccountStatement;
  return proto.fastcheckout.AccountStatement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.AccountStatement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.AccountStatement}
 */
proto.fastcheckout.AccountStatement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fastcheckout.Account;
      reader.readMessage(value,proto.fastcheckout.Account.deserializeBinaryFromReader);
      msg.setAccount(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Transaction;
      reader.readMessage(value,proto.fastcheckout.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setAccountpdfs(value);
      break;
    case 4:
      var value = new proto.fastcheckout.Loan;
      reader.readMessage(value,proto.fastcheckout.Loan.deserializeBinaryFromReader);
      msg.addLoans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.AccountStatement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.AccountStatement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.AccountStatement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountStatement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fastcheckout.Account.serializeBinaryToWriter
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fastcheckout.Transaction.serializeBinaryToWriter
    );
  }
  f = message.getAccountpdfs_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getLoansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.fastcheckout.Loan.serializeBinaryToWriter
    );
  }
};


/**
 * optional Account Account = 1;
 * @return {?proto.fastcheckout.Account}
 */
proto.fastcheckout.AccountStatement.prototype.getAccount = function() {
  return /** @type{?proto.fastcheckout.Account} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Account, 1));
};


/**
 * @param {?proto.fastcheckout.Account|undefined} value
 * @return {!proto.fastcheckout.AccountStatement} returns this
*/
proto.fastcheckout.AccountStatement.prototype.setAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.AccountStatement} returns this
 */
proto.fastcheckout.AccountStatement.prototype.clearAccount = function() {
  return this.setAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.AccountStatement.prototype.hasAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Transaction Transactions = 2;
 * @return {!Array<!proto.fastcheckout.Transaction>}
 */
proto.fastcheckout.AccountStatement.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Transaction, 2));
};


/**
 * @param {!Array<!proto.fastcheckout.Transaction>} value
 * @return {!proto.fastcheckout.AccountStatement} returns this
*/
proto.fastcheckout.AccountStatement.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fastcheckout.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Transaction}
 */
proto.fastcheckout.AccountStatement.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fastcheckout.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.AccountStatement} returns this
 */
proto.fastcheckout.AccountStatement.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional bytes AccountPdfs = 3;
 * @return {!(string|Uint8Array)}
 */
proto.fastcheckout.AccountStatement.prototype.getAccountpdfs = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes AccountPdfs = 3;
 * This is a type-conversion wrapper around `getAccountpdfs()`
 * @return {string}
 */
proto.fastcheckout.AccountStatement.prototype.getAccountpdfs_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getAccountpdfs()));
};


/**
 * optional bytes AccountPdfs = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAccountpdfs()`
 * @return {!Uint8Array}
 */
proto.fastcheckout.AccountStatement.prototype.getAccountpdfs_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getAccountpdfs()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fastcheckout.AccountStatement} returns this
 */
proto.fastcheckout.AccountStatement.prototype.setAccountpdfs = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * repeated Loan Loans = 4;
 * @return {!Array<!proto.fastcheckout.Loan>}
 */
proto.fastcheckout.AccountStatement.prototype.getLoansList = function() {
  return /** @type{!Array<!proto.fastcheckout.Loan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Loan, 4));
};


/**
 * @param {!Array<!proto.fastcheckout.Loan>} value
 * @return {!proto.fastcheckout.AccountStatement} returns this
*/
proto.fastcheckout.AccountStatement.prototype.setLoansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.fastcheckout.Loan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Loan}
 */
proto.fastcheckout.AccountStatement.prototype.addLoans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.fastcheckout.Loan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.AccountStatement} returns this
 */
proto.fastcheckout.AccountStatement.prototype.clearLoansList = function() {
  return this.setLoansList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.StatementTask.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.StatementTask.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.StatementTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.StatementTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.StatementTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    statementid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    login: jspb.Message.getFieldWithDefault(msg, 4, ""),
    secret: jspb.Message.getFieldWithDefault(msg, 5, ""),
    request: (f = msg.getRequest()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    failcount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lastattempt: (f = msg.getLastattempt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 9, 0),
    externalid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    channel: jspb.Message.getFieldWithDefault(msg, 11, ""),
    country: jspb.Message.getFieldWithDefault(msg, 12, ""),
    requestbankcodesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    isidp: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    substatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    update: (f = msg.getUpdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    siteresponse: jspb.Message.getFieldWithDefault(msg, 17, ""),
    challenge: (f = msg.getChallenge()) && proto.fastcheckout.Challenge.toObject(includeInstance, f),
    shortcode: jspb.Message.getFieldWithDefault(msg, 20, ""),
    consentgranted: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    systeminitiatedat: (f = msg.getSysteminitiatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    details: jspb.Message.getFieldWithDefault(msg, 23, ""),
    corporatecode: jspb.Message.getFieldWithDefault(msg, 24, ""),
    startdate: jspb.Message.getFieldWithDefault(msg, 25, ""),
    enddate: jspb.Message.getFieldWithDefault(msg, 26, ""),
    statusdesc: jspb.Message.getFieldWithDefault(msg, 27, ""),
    statuscode: jspb.Message.getFieldWithDefault(msg, 28, ""),
    istask: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    userconsent: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    timeconsentgranted: (f = msg.getTimeconsentgranted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    error: jspb.Message.getFieldWithDefault(msg, 32, ""),
    riskinsight: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
    includebalance: jspb.Message.getBooleanFieldWithDefault(msg, 34, false),
    accountlinkid: jspb.Message.getFieldWithDefault(msg, 35, ""),
    reconciliationid: jspb.Message.getFieldWithDefault(msg, 36, ""),
    customshortcode: jspb.Message.getFieldWithDefault(msg, 37, ""),
    parentstatementid: jspb.Message.getFieldWithDefault(msg, 38, ""),
    isrecon: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
    accountverification: jspb.Message.getBooleanFieldWithDefault(msg, 40, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.StatementTask}
 */
proto.fastcheckout.StatementTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.StatementTask;
  return proto.fastcheckout.StatementTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.StatementTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.StatementTask}
 */
proto.fastcheckout.StatementTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementid(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogin(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFailcount(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastattempt(value);
      break;
    case 9:
      var value = /** @type {!proto.fastcheckout.StatementTaskStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannel(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 13:
      var value = /** @type {!Array<!proto.fastcheckout.BankCode>} */ (reader.readPackedEnum());
      msg.setRequestbankcodesList(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsidp(value);
      break;
    case 15:
      var value = /** @type {!proto.fastcheckout.StatementSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdate(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteresponse(value);
      break;
    case 19:
      var value = new proto.fastcheckout.Challenge;
      reader.readMessage(value,proto.fastcheckout.Challenge.deserializeBinaryFromReader);
      msg.setChallenge(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortcode(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsentgranted(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSysteminitiatedat(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporatecode(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnddate(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdesc(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscode(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIstask(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserconsent(value);
      break;
    case 31:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimeconsentgranted(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRiskinsight(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludebalance(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountlinkid(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setReconciliationid(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomshortcode(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentstatementid(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecon(value);
      break;
    case 40:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccountverification(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.StatementTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.StatementTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.StatementTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.StatementTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatementid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLogin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFailcount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLastattempt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getExternalid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRequestbankcodesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      13,
      f
    );
  }
  f = message.getIsidp();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getUpdate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSiteresponse();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getChallenge();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.fastcheckout.Challenge.serializeBinaryToWriter
    );
  }
  f = message.getShortcode();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getConsentgranted();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getSysteminitiatedat();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getCorporatecode();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getEnddate();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getStatusdesc();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getIstask();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getUserconsent();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getTimeconsentgranted();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getRiskinsight();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getIncludebalance();
  if (f) {
    writer.writeBool(
      34,
      f
    );
  }
  f = message.getAccountlinkid();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getReconciliationid();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getCustomshortcode();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getParentstatementid();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getIsrecon();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getAccountverification();
  if (f) {
    writer.writeBool(
      40,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string StatementID = 2;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getStatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setStatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional BankCode BankCode = 3;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.StatementTask.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Login = 4;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getLogin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setLogin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Secret = 5;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp Request = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.StatementTask.prototype.getRequest = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 FailCount = 7;
 * @return {number}
 */
proto.fastcheckout.StatementTask.prototype.getFailcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setFailcount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp LastAttempt = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.StatementTask.prototype.getLastattempt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setLastattempt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearLastattempt = function() {
  return this.setLastattempt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasLastattempt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional StatementTaskStatus Status = 9;
 * @return {!proto.fastcheckout.StatementTaskStatus}
 */
proto.fastcheckout.StatementTask.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.StatementTaskStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.fastcheckout.StatementTaskStatus} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string ExternalID = 10;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getExternalid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setExternalid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Channel = 11;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Country = 12;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated BankCode RequestBankcodes = 13;
 * @return {!Array<!proto.fastcheckout.BankCode>}
 */
proto.fastcheckout.StatementTask.prototype.getRequestbankcodesList = function() {
  return /** @type {!Array<!proto.fastcheckout.BankCode>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<!proto.fastcheckout.BankCode>} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setRequestbankcodesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.addRequestbankcodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearRequestbankcodesList = function() {
  return this.setRequestbankcodesList([]);
};


/**
 * optional bool IsIDP = 14;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getIsidp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setIsidp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional StatementSubStatus SubStatus = 15;
 * @return {!proto.fastcheckout.StatementSubStatus}
 */
proto.fastcheckout.StatementTask.prototype.getSubstatus = function() {
  return /** @type {!proto.fastcheckout.StatementSubStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.fastcheckout.StatementSubStatus} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional google.protobuf.Timestamp Update = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.StatementTask.prototype.getUpdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearUpdate = function() {
  return this.setUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasUpdate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string SiteResponse = 17;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getSiteresponse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setSiteresponse = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional Challenge Challenge = 19;
 * @return {?proto.fastcheckout.Challenge}
 */
proto.fastcheckout.StatementTask.prototype.getChallenge = function() {
  return /** @type{?proto.fastcheckout.Challenge} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Challenge, 19));
};


/**
 * @param {?proto.fastcheckout.Challenge|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setChallenge = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearChallenge = function() {
  return this.setChallenge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasChallenge = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string ShortCode = 20;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getShortcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setShortcode = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional bool ConsentGranted = 21;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getConsentgranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setConsentgranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional google.protobuf.Timestamp SystemInitiatedAt = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.StatementTask.prototype.getSysteminitiatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setSysteminitiatedat = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearSysteminitiatedat = function() {
  return this.setSysteminitiatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasSysteminitiatedat = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional string Details = 23;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string CorporateCode = 24;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getCorporatecode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setCorporatecode = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string StartDate = 25;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setStartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string EndDate = 26;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getEnddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setEnddate = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string StatusDesc = 27;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getStatusdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setStatusdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string StatusCode = 28;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getStatuscode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setStatuscode = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional bool IsTask = 29;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getIstask = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setIstask = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool UserConsent = 30;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getUserconsent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setUserconsent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional google.protobuf.Timestamp TimeConsentGranted = 31;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.StatementTask.prototype.getTimeconsentgranted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 31));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.StatementTask} returns this
*/
proto.fastcheckout.StatementTask.prototype.setTimeconsentgranted = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.clearTimeconsentgranted = function() {
  return this.setTimeconsentgranted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.hasTimeconsentgranted = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional string Error = 32;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional bool RiskInsight = 33;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getRiskinsight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setRiskinsight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional bool IncludeBalance = 34;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getIncludebalance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setIncludebalance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 34, value);
};


/**
 * optional string AccountLinkID = 35;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getAccountlinkid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setAccountlinkid = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string ReconciliationID = 36;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getReconciliationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setReconciliationid = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string CustomShortCode = 37;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getCustomshortcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setCustomshortcode = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string ParentStatementID = 38;
 * @return {string}
 */
proto.fastcheckout.StatementTask.prototype.getParentstatementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setParentstatementid = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional bool IsRecon = 39;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getIsrecon = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setIsrecon = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * optional bool AccountVerification = 40;
 * @return {boolean}
 */
proto.fastcheckout.StatementTask.prototype.getAccountverification = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 40, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.StatementTask} returns this
 */
proto.fastcheckout.StatementTask.prototype.setAccountverification = function(value) {
  return jspb.Message.setProto3BooleanField(this, 40, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.FundTransferTask.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.FundTransferTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.FundTransferTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transferid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creds: (f = msg.getCreds()) && proto.fastcheckout.Credential.toObject(includeInstance, f),
    from: (f = msg.getFrom()) && proto.fastcheckout.AccountInfo.toObject(includeInstance, f),
    to: (f = msg.getTo()) && proto.fastcheckout.DestinationAccountInfo.toObject(includeInstance, f),
    amount: (f = msg.getAmount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    usermemo: jspb.Message.getFieldWithDefault(msg, 7, ""),
    bankmemo: jspb.Message.getFieldWithDefault(msg, 8, ""),
    error: jspb.Message.getFieldWithDefault(msg, 9, ""),
    request: (f = msg.getRequest()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    finish: (f = msg.getFinish()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 12, 0),
    paymentchannel: jspb.Message.getFieldWithDefault(msg, 13, 0),
    settlementid: jspb.Message.getFieldWithDefault(msg, 14, ""),
    customer: (f = msg.getCustomer()) && proto.fastcheckout.Customer.toObject(includeInstance, f),
    origto: (f = msg.getOrigto()) && proto.fastcheckout.DestinationAccountInfo.toObject(includeInstance, f),
    referenceid: jspb.Message.getFieldWithDefault(msg, 17, ""),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    bankreferencecode: jspb.Message.getFieldWithDefault(msg, 19, ""),
    consentgranted: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    qrcode: (f = msg.getQrcode()) && proto.fastcheckout.QRCode.toObject(includeInstance, f),
    bankinteractionmethod: jspb.Message.getFieldWithDefault(msg, 22, 0),
    additionaldetails: (f = msg.getAdditionaldetails()) && proto.fastcheckout.AdditionalDetails.toObject(includeInstance, f),
    expirydatetime: (f = msg.getExpirydatetime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    statuscode: jspb.Message.getFieldWithDefault(msg, 25, ""),
    statusdesc: jspb.Message.getFieldWithDefault(msg, 26, ""),
    origamount: (f = msg.getOrigamount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    details: jspb.Message.getFieldWithDefault(msg, 28, ""),
    transactionid: jspb.Message.getFieldWithDefault(msg, 29, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.FundTransferTask}
 */
proto.fastcheckout.FundTransferTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.FundTransferTask;
  return proto.fastcheckout.FundTransferTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.FundTransferTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.FundTransferTask}
 */
proto.fastcheckout.FundTransferTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransferid(value);
      break;
    case 3:
      var value = new proto.fastcheckout.Credential;
      reader.readMessage(value,proto.fastcheckout.Credential.deserializeBinaryFromReader);
      msg.setCreds(value);
      break;
    case 4:
      var value = new proto.fastcheckout.AccountInfo;
      reader.readMessage(value,proto.fastcheckout.AccountInfo.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 5:
      var value = new proto.fastcheckout.DestinationAccountInfo;
      reader.readMessage(value,proto.fastcheckout.DestinationAccountInfo.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 6:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsermemo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankmemo(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinish(value);
      break;
    case 12:
      var value = /** @type {!proto.fastcheckout.FundTransferTaskStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {!proto.fastcheckout.PaymentChannelType} */ (reader.readEnum());
      msg.setPaymentchannel(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementid(value);
      break;
    case 15:
      var value = new proto.fastcheckout.Customer;
      reader.readMessage(value,proto.fastcheckout.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 16:
      var value = new proto.fastcheckout.DestinationAccountInfo;
      reader.readMessage(value,proto.fastcheckout.DestinationAccountInfo.deserializeBinaryFromReader);
      msg.setOrigto(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceid(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankreferencecode(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConsentgranted(value);
      break;
    case 21:
      var value = new proto.fastcheckout.QRCode;
      reader.readMessage(value,proto.fastcheckout.QRCode.deserializeBinaryFromReader);
      msg.setQrcode(value);
      break;
    case 22:
      var value = /** @type {!proto.fastcheckout.BankInteractionMethod} */ (reader.readEnum());
      msg.setBankinteractionmethod(value);
      break;
    case 23:
      var value = new proto.fastcheckout.AdditionalDetails;
      reader.readMessage(value,proto.fastcheckout.AdditionalDetails.deserializeBinaryFromReader);
      msg.setAdditionaldetails(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirydatetime(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscode(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdesc(value);
      break;
    case 27:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setOrigamount(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.FundTransferTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.FundTransferTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.FundTransferTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransferid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreds();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.fastcheckout.Credential.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.fastcheckout.AccountInfo.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.fastcheckout.DestinationAccountInfo.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getUsermemo();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBankmemo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinish();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getPaymentchannel();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getSettlementid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.fastcheckout.Customer.serializeBinaryToWriter
    );
  }
  f = message.getOrigto();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.fastcheckout.DestinationAccountInfo.serializeBinaryToWriter
    );
  }
  f = message.getReferenceid();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBankreferencecode();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getConsentgranted();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getQrcode();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.fastcheckout.QRCode.serializeBinaryToWriter
    );
  }
  f = message.getBankinteractionmethod();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getAdditionaldetails();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.fastcheckout.AdditionalDetails.serializeBinaryToWriter
    );
  }
  f = message.getExpirydatetime();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getStatusdesc();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getOrigamount();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string TransferID = 2;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getTransferid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setTransferid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Credential Creds = 3;
 * @return {?proto.fastcheckout.Credential}
 */
proto.fastcheckout.FundTransferTask.prototype.getCreds = function() {
  return /** @type{?proto.fastcheckout.Credential} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Credential, 3));
};


/**
 * @param {?proto.fastcheckout.Credential|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setCreds = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearCreds = function() {
  return this.setCreds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasCreds = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AccountInfo From = 4;
 * @return {?proto.fastcheckout.AccountInfo}
 */
proto.fastcheckout.FundTransferTask.prototype.getFrom = function() {
  return /** @type{?proto.fastcheckout.AccountInfo} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.AccountInfo, 4));
};


/**
 * @param {?proto.fastcheckout.AccountInfo|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DestinationAccountInfo To = 5;
 * @return {?proto.fastcheckout.DestinationAccountInfo}
 */
proto.fastcheckout.FundTransferTask.prototype.getTo = function() {
  return /** @type{?proto.fastcheckout.DestinationAccountInfo} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.DestinationAccountInfo, 5));
};


/**
 * @param {?proto.fastcheckout.DestinationAccountInfo|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasTo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Amount Amount = 6;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.FundTransferTask.prototype.getAmount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 6));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string UserMemo = 7;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getUsermemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setUsermemo = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string BankMemo = 8;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getBankmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setBankmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Error = 9;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp Request = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FundTransferTask.prototype.getRequest = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp Finish = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FundTransferTask.prototype.getFinish = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setFinish = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearFinish = function() {
  return this.setFinish(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasFinish = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional FundTransferTaskStatus Status = 12;
 * @return {!proto.fastcheckout.FundTransferTaskStatus}
 */
proto.fastcheckout.FundTransferTask.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.FundTransferTaskStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.fastcheckout.FundTransferTaskStatus} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional PaymentChannelType PaymentChannel = 13;
 * @return {!proto.fastcheckout.PaymentChannelType}
 */
proto.fastcheckout.FundTransferTask.prototype.getPaymentchannel = function() {
  return /** @type {!proto.fastcheckout.PaymentChannelType} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.fastcheckout.PaymentChannelType} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setPaymentchannel = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string SettlementID = 14;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getSettlementid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setSettlementid = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Customer Customer = 15;
 * @return {?proto.fastcheckout.Customer}
 */
proto.fastcheckout.FundTransferTask.prototype.getCustomer = function() {
  return /** @type{?proto.fastcheckout.Customer} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Customer, 15));
};


/**
 * @param {?proto.fastcheckout.Customer|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional DestinationAccountInfo OrigTo = 16;
 * @return {?proto.fastcheckout.DestinationAccountInfo}
 */
proto.fastcheckout.FundTransferTask.prototype.getOrigto = function() {
  return /** @type{?proto.fastcheckout.DestinationAccountInfo} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.DestinationAccountInfo, 16));
};


/**
 * @param {?proto.fastcheckout.DestinationAccountInfo|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setOrigto = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearOrigto = function() {
  return this.setOrigto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasOrigto = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string ReferenceID = 17;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getReferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setReferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp Updated = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FundTransferTask.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string BankReferenceCode = 19;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getBankreferencecode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setBankreferencecode = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional bool ConsentGranted = 20;
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.getConsentgranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setConsentgranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional QRCode QRCode = 21;
 * @return {?proto.fastcheckout.QRCode}
 */
proto.fastcheckout.FundTransferTask.prototype.getQrcode = function() {
  return /** @type{?proto.fastcheckout.QRCode} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.QRCode, 21));
};


/**
 * @param {?proto.fastcheckout.QRCode|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setQrcode = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearQrcode = function() {
  return this.setQrcode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasQrcode = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional BankInteractionMethod BankInteractionMethod = 22;
 * @return {!proto.fastcheckout.BankInteractionMethod}
 */
proto.fastcheckout.FundTransferTask.prototype.getBankinteractionmethod = function() {
  return /** @type {!proto.fastcheckout.BankInteractionMethod} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.fastcheckout.BankInteractionMethod} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setBankinteractionmethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional AdditionalDetails AdditionalDetails = 23;
 * @return {?proto.fastcheckout.AdditionalDetails}
 */
proto.fastcheckout.FundTransferTask.prototype.getAdditionaldetails = function() {
  return /** @type{?proto.fastcheckout.AdditionalDetails} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.AdditionalDetails, 23));
};


/**
 * @param {?proto.fastcheckout.AdditionalDetails|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setAdditionaldetails = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearAdditionaldetails = function() {
  return this.setAdditionaldetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasAdditionaldetails = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp ExpiryDateTime = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FundTransferTask.prototype.getExpirydatetime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setExpirydatetime = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearExpirydatetime = function() {
  return this.setExpirydatetime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasExpirydatetime = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional string StatusCode = 25;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getStatuscode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setStatuscode = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string StatusDesc = 26;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getStatusdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setStatusdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional Amount OrigAmount = 27;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.FundTransferTask.prototype.getOrigamount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 27));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
*/
proto.fastcheckout.FundTransferTask.prototype.setOrigamount = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.clearOrigamount = function() {
  return this.setOrigamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferTask.prototype.hasOrigamount = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string Details = 28;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string TransactionID = 29;
 * @return {string}
 */
proto.fastcheckout.FundTransferTask.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferTask} returns this
 */
proto.fastcheckout.FundTransferTask.prototype.setTransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.AdditionalDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.AdditionalDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.AdditionalDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AdditionalDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    qrcoderawdata: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountaliasid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    toaddressline1: jspb.Message.getFieldWithDefault(msg, 3, ""),
    toaddressline2: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tocity: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tostate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tocountry: jspb.Message.getFieldWithDefault(msg, 7, ""),
    termsofuseversion: jspb.Message.getFieldWithDefault(msg, 8, ""),
    privacypolicyversion: jspb.Message.getFieldWithDefault(msg, 9, ""),
    useridhash: jspb.Message.getFieldWithDefault(msg, 10, ""),
    useraccesshash: jspb.Message.getFieldWithDefault(msg, 11, ""),
    useraccounthash: jspb.Message.getFieldWithDefault(msg, 12, ""),
    via: jspb.Message.getFieldWithDefault(msg, 13, 0),
    bankfee: (f = msg.getBankfee()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    settlementidentifier: jspb.Message.getFieldWithDefault(msg, 15, ""),
    settlementidentifieralias: jspb.Message.getFieldWithDefault(msg, 16, ""),
    redirecturl: jspb.Message.getFieldWithDefault(msg, 17, ""),
    phonenumberselectionMap: (f = msg.getPhonenumberselectionMap()) ? f.toObject(includeInstance, undefined) : [],
    visatransactionid: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.AdditionalDetails}
 */
proto.fastcheckout.AdditionalDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.AdditionalDetails;
  return proto.fastcheckout.AdditionalDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.AdditionalDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.AdditionalDetails}
 */
proto.fastcheckout.AdditionalDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQrcoderawdata(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountaliasid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToaddressline1(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToaddressline2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTocity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTostate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTocountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTermsofuseversion(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivacypolicyversion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUseridhash(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUseraccesshash(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUseraccounthash(value);
      break;
    case 13:
      var value = /** @type {!proto.fastcheckout.Via} */ (reader.readEnum());
      msg.setVia(value);
      break;
    case 14:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setBankfee(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementidentifier(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementidentifieralias(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedirecturl(value);
      break;
    case 18:
      var value = msg.getPhonenumberselectionMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisatransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.AdditionalDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.AdditionalDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.AdditionalDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AdditionalDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQrcoderawdata();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountaliasid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getToaddressline1();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToaddressline2();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTocity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTostate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTocountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTermsofuseversion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrivacypolicyversion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUseridhash();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUseraccesshash();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUseraccounthash();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getVia();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getBankfee();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getSettlementidentifier();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSettlementidentifieralias();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRedirecturl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPhonenumberselectionMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(18, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getVisatransactionid();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string QRCodeRawData = 1;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getQrcoderawdata = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setQrcoderawdata = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string AccountAliasID = 2;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getAccountaliasid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setAccountaliasid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ToAddressLine1 = 3;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getToaddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setToaddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ToAddressLine2 = 4;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getToaddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setToaddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ToCity = 5;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getTocity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setTocity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ToState = 6;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getTostate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setTostate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string ToCountry = 7;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getTocountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setTocountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string TermsOfUseVersion = 8;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getTermsofuseversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setTermsofuseversion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string PrivacyPolicyVersion = 9;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getPrivacypolicyversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setPrivacypolicyversion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string UserIdHash = 10;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getUseridhash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setUseridhash = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string UserAccessHash = 11;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getUseraccesshash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setUseraccesshash = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string UserAccountHash = 12;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getUseraccounthash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setUseraccounthash = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional Via Via = 13;
 * @return {!proto.fastcheckout.Via}
 */
proto.fastcheckout.AdditionalDetails.prototype.getVia = function() {
  return /** @type {!proto.fastcheckout.Via} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.fastcheckout.Via} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setVia = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional Amount BankFee = 14;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.AdditionalDetails.prototype.getBankfee = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 14));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
*/
proto.fastcheckout.AdditionalDetails.prototype.setBankfee = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.clearBankfee = function() {
  return this.setBankfee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.AdditionalDetails.prototype.hasBankfee = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string SettlementIdentifier = 15;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getSettlementidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setSettlementidentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string SettlementIdentifierAlias = 16;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getSettlementidentifieralias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setSettlementidentifieralias = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string RedirectURL = 17;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getRedirecturl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setRedirecturl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * map<string, string> PhoneNumberSelection = 18;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.fastcheckout.AdditionalDetails.prototype.getPhonenumberselectionMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 18, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.clearPhonenumberselectionMap = function() {
  this.getPhonenumberselectionMap().clear();
  return this;};


/**
 * optional string VisaTransactionID = 19;
 * @return {string}
 */
proto.fastcheckout.AdditionalDetails.prototype.getVisatransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AdditionalDetails} returns this
 */
proto.fastcheckout.AdditionalDetails.prototype.setVisatransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.QRCode.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.QRCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.QRCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.QRCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    encoded: jspb.Message.getFieldWithDefault(msg, 1, ""),
    decoded: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.QRCode}
 */
proto.fastcheckout.QRCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.QRCode;
  return proto.fastcheckout.QRCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.QRCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.QRCode}
 */
proto.fastcheckout.QRCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncoded(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDecoded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.QRCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.QRCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.QRCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.QRCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncoded();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDecoded();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Encoded = 1;
 * @return {string}
 */
proto.fastcheckout.QRCode.prototype.getEncoded = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.QRCode} returns this
 */
proto.fastcheckout.QRCode.prototype.setEncoded = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Decoded = 2;
 * @return {string}
 */
proto.fastcheckout.QRCode.prototype.getDecoded = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.QRCode} returns this
 */
proto.fastcheckout.QRCode.prototype.setDecoded = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Settlement.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Settlement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Settlement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Settlement.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    responseid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responsecode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, ""),
    timestamp: (f = msg.getTimestamp()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Settlement}
 */
proto.fastcheckout.Settlement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Settlement;
  return proto.fastcheckout.Settlement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Settlement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Settlement}
 */
proto.fastcheckout.Settlement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseid(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.SettlementResponseCode} */ (reader.readEnum());
      msg.setResponsecode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Settlement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Settlement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Settlement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Settlement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponseid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponsecode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.Settlement.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Settlement} returns this
 */
proto.fastcheckout.Settlement.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ResponseID = 2;
 * @return {string}
 */
proto.fastcheckout.Settlement.prototype.getResponseid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Settlement} returns this
 */
proto.fastcheckout.Settlement.prototype.setResponseid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SettlementResponseCode ResponseCode = 3;
 * @return {!proto.fastcheckout.SettlementResponseCode}
 */
proto.fastcheckout.Settlement.prototype.getResponsecode = function() {
  return /** @type {!proto.fastcheckout.SettlementResponseCode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.SettlementResponseCode} value
 * @return {!proto.fastcheckout.Settlement} returns this
 */
proto.fastcheckout.Settlement.prototype.setResponsecode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Status = 4;
 * @return {string}
 */
proto.fastcheckout.Settlement.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Settlement} returns this
 */
proto.fastcheckout.Settlement.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp Timestamp = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Settlement.prototype.getTimestamp = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Settlement} returns this
*/
proto.fastcheckout.Settlement.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Settlement} returns this
 */
proto.fastcheckout.Settlement.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Settlement.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Filter.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Filter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Filter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Filter.toObject = function(includeInstance, msg) {
  var f, obj = {
    operation: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filterterm: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Filter}
 */
proto.fastcheckout.Filter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Filter;
  return proto.fastcheckout.Filter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Filter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Filter}
 */
proto.fastcheckout.Filter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperation(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilterterm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Filter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Filter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Filter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Filter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOperation();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilterterm();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Operation = 1;
 * @return {string}
 */
proto.fastcheckout.Filter.prototype.getOperation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Filter} returns this
 */
proto.fastcheckout.Filter.prototype.setOperation = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FilterTerm = 2;
 * @return {string}
 */
proto.fastcheckout.Filter.prototype.getFilterterm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Filter} returns this
 */
proto.fastcheckout.Filter.prototype.setFilterterm = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.FilterField.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.FilterField.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.FilterField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.FilterField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FilterField.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filterList: jspb.Message.toObjectList(msg.getFilterList(),
    proto.fastcheckout.Filter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.FilterField}
 */
proto.fastcheckout.FilterField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.FilterField;
  return proto.fastcheckout.FilterField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.FilterField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.FilterField}
 */
proto.fastcheckout.FilterField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Filter;
      reader.readMessage(value,proto.fastcheckout.Filter.deserializeBinaryFromReader);
      msg.addFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.FilterField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.FilterField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.FilterField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FilterField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fastcheckout.Filter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.fastcheckout.FilterField.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FilterField} returns this
 */
proto.fastcheckout.FilterField.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Filter Filter = 2;
 * @return {!Array<!proto.fastcheckout.Filter>}
 */
proto.fastcheckout.FilterField.prototype.getFilterList = function() {
  return /** @type{!Array<!proto.fastcheckout.Filter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Filter, 2));
};


/**
 * @param {!Array<!proto.fastcheckout.Filter>} value
 * @return {!proto.fastcheckout.FilterField} returns this
*/
proto.fastcheckout.FilterField.prototype.setFilterList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fastcheckout.Filter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Filter}
 */
proto.fastcheckout.FilterField.prototype.addFilter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fastcheckout.Filter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.FilterField} returns this
 */
proto.fastcheckout.FilterField.prototype.clearFilterList = function() {
  return this.setFilterList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.FetchSourceAccountsTask.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.FetchSourceAccountsTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.FetchSourceAccountsTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FetchSourceAccountsTask.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    creds: (f = msg.getCreds()) && proto.fastcheckout.Credential.toObject(includeInstance, f),
    bankcode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    error: jspb.Message.getFieldWithDefault(msg, 5, ""),
    request: (f = msg.getRequest()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    finish: (f = msg.getFinish()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.fastcheckout.Account.toObject, includeInstance),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    bankmemo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    challenge: jspb.Message.getFieldWithDefault(msg, 12, ""),
    transactionid: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask}
 */
proto.fastcheckout.FetchSourceAccountsTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.FetchSourceAccountsTask;
  return proto.fastcheckout.FetchSourceAccountsTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.FetchSourceAccountsTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask}
 */
proto.fastcheckout.FetchSourceAccountsTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = new proto.fastcheckout.Credential;
      reader.readMessage(value,proto.fastcheckout.Credential.deserializeBinaryFromReader);
      msg.setCreds(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinish(value);
      break;
    case 8:
      var value = /** @type {!proto.fastcheckout.FetchAccountsTaskStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = new proto.fastcheckout.Account;
      reader.readMessage(value,proto.fastcheckout.Account.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankmemo(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setChallenge(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.FetchSourceAccountsTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.FetchSourceAccountsTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FetchSourceAccountsTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreds();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.fastcheckout.Credential.serializeBinaryToWriter
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinish();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.fastcheckout.Account.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBankmemo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getChallenge();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Credential Creds = 3;
 * @return {?proto.fastcheckout.Credential}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getCreds = function() {
  return /** @type{?proto.fastcheckout.Credential} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Credential, 3));
};


/**
 * @param {?proto.fastcheckout.Credential|undefined} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
*/
proto.fastcheckout.FetchSourceAccountsTask.prototype.setCreds = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.clearCreds = function() {
  return this.setCreds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.hasCreds = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional BankCode BankCode = 4;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string Error = 5;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp Request = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getRequest = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
*/
proto.fastcheckout.FetchSourceAccountsTask.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp Finish = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getFinish = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
*/
proto.fastcheckout.FetchSourceAccountsTask.prototype.setFinish = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.clearFinish = function() {
  return this.setFinish(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.hasFinish = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional FetchAccountsTaskStatus Status = 8;
 * @return {!proto.fastcheckout.FetchAccountsTaskStatus}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.FetchAccountsTaskStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.fastcheckout.FetchAccountsTaskStatus} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated Account Accounts = 9;
 * @return {!Array<!proto.fastcheckout.Account>}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.fastcheckout.Account>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Account, 9));
};


/**
 * @param {!Array<!proto.fastcheckout.Account>} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
*/
proto.fastcheckout.FetchSourceAccountsTask.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.fastcheckout.Account=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Account}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.fastcheckout.Account, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};


/**
 * optional google.protobuf.Timestamp Updated = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
*/
proto.fastcheckout.FetchSourceAccountsTask.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string BankMemo = 11;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getBankmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setBankmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string Challenge = 12;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getChallenge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setChallenge = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string TransactionID = 13;
 * @return {string}
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FetchSourceAccountsTask} returns this
 */
proto.fastcheckout.FetchSourceAccountsTask.prototype.setTransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.BusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.BusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.BusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.BusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 3, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 4, ""),
    city: jspb.Message.getFieldWithDefault(msg, 5, ""),
    stateprovince: jspb.Message.getFieldWithDefault(msg, 6, ""),
    country: jspb.Message.getFieldWithDefault(msg, 7, ""),
    emailaddress: jspb.Message.getFieldWithDefault(msg, 8, ""),
    mobilecountrycode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    mobilenumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 11, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    supportretries: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.BusinessInfo}
 */
proto.fastcheckout.BusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.BusinessInfo;
  return proto.fastcheckout.BusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.BusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.BusinessInfo}
 */
proto.fastcheckout.BusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateprovince(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailaddress(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilecountrycode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilenumber(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportretries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.BusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.BusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.BusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.BusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStateprovince();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmailaddress();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMobilecountrycode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMobilenumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getSupportretries();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AddressLine1 = 3;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AddressLine2 = 4;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string City = 5;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string StateProvince = 6;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getStateprovince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setStateprovince = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Country = 7;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string EmailAddress = 8;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getEmailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setEmailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string MobileCountryCode = 9;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getMobilecountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setMobilecountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string MobileNumber = 10;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getMobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setMobilenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string OrgID = 11;
 * @return {string}
 */
proto.fastcheckout.BusinessInfo.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool Enabled = 12;
 * @return {boolean}
 */
proto.fastcheckout.BusinessInfo.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool SupportRetries = 13;
 * @return {boolean}
 */
proto.fastcheckout.BusinessInfo.prototype.getSupportretries = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BusinessInfo} returns this
 */
proto.fastcheckout.BusinessInfo.prototype.setSupportretries = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.DestinationAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.DestinationAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.DestinationAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    businessinfoid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    accountnumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    bankidentifier: jspb.Message.getFieldWithDefault(msg, 6, ""),
    settlementidentifier: jspb.Message.getFieldWithDefault(msg, 7, ""),
    holderfirstname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    holdermiddlename: jspb.Message.getFieldWithDefault(msg, 9, ""),
    holderlastname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    holderemail: jspb.Message.getFieldWithDefault(msg, 12, ""),
    holdermobilecountrycode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    holdermobilenumber: jspb.Message.getFieldWithDefault(msg, 14, ""),
    accountaliasid: jspb.Message.getFieldWithDefault(msg, 15, ""),
    settlementidentifieralias: jspb.Message.getFieldWithDefault(msg, 16, ""),
    accounttype: jspb.Message.getFieldWithDefault(msg, 17, 0),
    visapan: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.DestinationAccount}
 */
proto.fastcheckout.DestinationAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.DestinationAccount;
  return proto.fastcheckout.DestinationAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.DestinationAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.DestinationAccount}
 */
proto.fastcheckout.DestinationAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessinfoid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankidentifier(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementidentifier(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderfirstname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldermiddlename(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderlastname(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderemail(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldermobilecountrycode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldermobilenumber(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountaliasid(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementidentifieralias(value);
      break;
    case 17:
      var value = /** @type {!proto.fastcheckout.AccountType} */ (reader.readEnum());
      msg.setAccounttype(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisapan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.DestinationAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.DestinationAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.DestinationAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBusinessinfoid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBankidentifier();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSettlementidentifier();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHolderfirstname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getHoldermiddlename();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getHolderlastname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getHolderemail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHoldermobilecountrycode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getHoldermobilenumber();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAccountaliasid();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSettlementidentifieralias();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAccounttype();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getVisapan();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string BusinessInfoID = 2;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getBusinessinfoid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setBusinessinfoid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string OrgID = 3;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional DestinationBankCode BankCode = 4;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.fastcheckout.DestinationAccount.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string AccountNumber = 5;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string BankIdentifier = 6;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getBankidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setBankidentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string SettlementIdentifier = 7;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getSettlementidentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setSettlementidentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string HolderFirstName = 8;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHolderfirstname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHolderfirstname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string HolderMiddleName = 9;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHoldermiddlename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHoldermiddlename = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string HolderLastName = 10;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHolderlastname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHolderlastname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool Enabled = 11;
 * @return {boolean}
 */
proto.fastcheckout.DestinationAccount.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string HolderEmail = 12;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHolderemail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHolderemail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string HolderMobileCountryCode = 13;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHoldermobilecountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHoldermobilecountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string HolderMobileNumber = 14;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getHoldermobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setHoldermobilenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string AccountAliasID = 15;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getAccountaliasid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setAccountaliasid = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string SettlementIdentifierAlias = 16;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getSettlementidentifieralias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setSettlementidentifieralias = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional AccountType AccountType = 17;
 * @return {!proto.fastcheckout.AccountType}
 */
proto.fastcheckout.DestinationAccount.prototype.getAccounttype = function() {
  return /** @type {!proto.fastcheckout.AccountType} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.fastcheckout.AccountType} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setAccounttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional string VisaPAN = 18;
 * @return {string}
 */
proto.fastcheckout.DestinationAccount.prototype.getVisapan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccount} returns this
 */
proto.fastcheckout.DestinationAccount.prototype.setVisapan = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Client.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    logourl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    returnurl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    statementretrieval: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    failurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    encryptedcredential: jspb.Message.getFieldWithDefault(msg, 6, ""),
    deeplink: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    headertext: jspb.Message.getFieldWithDefault(msg, 8, ""),
    shortredirecturi: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    language: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Client}
 */
proto.fastcheckout.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Client;
  return proto.fastcheckout.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Client}
 */
proto.fastcheckout.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogourl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReturnurl(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatementretrieval(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailurl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncryptedcredential(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeeplink(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadertext(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShortredirecturi(value);
      break;
    case 10:
      var value = /** @type {!proto.fastcheckout.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogourl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReturnurl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatementretrieval();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFailurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEncryptedcredential();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDeeplink();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getHeadertext();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getShortredirecturi();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional string DisplayName = 1;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setDisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string LogoURL = 2;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getLogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setLogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ReturnURL = 3;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getReturnurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setReturnurl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool StatementRetrieval = 4;
 * @return {boolean}
 */
proto.fastcheckout.Client.prototype.getStatementretrieval = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setStatementretrieval = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string FailURL = 5;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getFailurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setFailurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string EncryptedCredential = 6;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getEncryptedcredential = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setEncryptedcredential = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool DeepLink = 7;
 * @return {boolean}
 */
proto.fastcheckout.Client.prototype.getDeeplink = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setDeeplink = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string HeaderText = 8;
 * @return {string}
 */
proto.fastcheckout.Client.prototype.getHeadertext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setHeadertext = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool ShortRedirectURI = 9;
 * @return {boolean}
 */
proto.fastcheckout.Client.prototype.getShortredirecturi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setShortredirecturi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional Language Language = 10;
 * @return {!proto.fastcheckout.Language}
 */
proto.fastcheckout.Client.prototype.getLanguage = function() {
  return /** @type {!proto.fastcheckout.Language} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.fastcheckout.Language} value
 * @return {!proto.fastcheckout.Client} returns this
 */
proto.fastcheckout.Client.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Report.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Report.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Report} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Report.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    date: jspb.Message.getFieldWithDefault(msg, 5, ""),
    link: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    country: jspb.Message.getFieldWithDefault(msg, 10, 0),
    fromdate: jspb.Message.getFieldWithDefault(msg, 11, ""),
    todate: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Report}
 */
proto.fastcheckout.Report.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Report;
  return proto.fastcheckout.Report.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Report} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Report}
 */
proto.fastcheckout.Report.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.ReportType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLink(value);
      break;
    case 7:
      var value = /** @type {!proto.fastcheckout.ReportStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    case 10:
      var value = /** @type {!proto.fastcheckout.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFromdate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTodate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Report.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Report.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Report} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Report.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLink();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getFromdate();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTodate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ReportType Type = 3;
 * @return {!proto.fastcheckout.ReportType}
 */
proto.fastcheckout.Report.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.ReportType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.ReportType} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Date = 5;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Link = 6;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setLink = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ReportStatus Status = 7;
 * @return {!proto.fastcheckout.ReportStatus}
 */
proto.fastcheckout.Report.prototype.getStatus = function() {
  return /** @type {!proto.fastcheckout.ReportStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.fastcheckout.ReportStatus} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp Created = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Report.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Report} returns this
*/
proto.fastcheckout.Report.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Report.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp Updated = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.Report.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.Report} returns this
*/
proto.fastcheckout.Report.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Report.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CountryISO3166 Country = 10;
 * @return {!proto.fastcheckout.CountryISO3166}
 */
proto.fastcheckout.Report.prototype.getCountry = function() {
  return /** @type {!proto.fastcheckout.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.fastcheckout.CountryISO3166} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string FromDate = 11;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getFromdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setFromdate = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string ToDate = 12;
 * @return {string}
 */
proto.fastcheckout.Report.prototype.getTodate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Report} returns this
 */
proto.fastcheckout.Report.prototype.setTodate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.TransactionLog.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.TransactionLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.TransactionLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.TransactionLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    transactionid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    statuscode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    statuscodefrom: jspb.Message.getFieldWithDefault(msg, 5, ""),
    statusdesc: jspb.Message.getFieldWithDefault(msg, 6, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.TransactionLog}
 */
proto.fastcheckout.TransactionLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.TransactionLog;
  return proto.fastcheckout.TransactionLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.TransactionLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.TransactionLog}
 */
proto.fastcheckout.TransactionLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatuscodefrom(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusdesc(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.TransactionLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.TransactionLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.TransactionLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.TransactionLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTransactionid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatuscode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatuscodefrom();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatusdesc();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string TransactionID = 3;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getTransactionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setTransactionid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string StatusCode = 4;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getStatuscode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setStatuscode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string StatusCodeFrom = 5;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getStatuscodefrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setStatuscodefrom = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string StatusDesc = 6;
 * @return {string}
 */
proto.fastcheckout.TransactionLog.prototype.getStatusdesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.setStatusdesc = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp Created = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.TransactionLog.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
*/
proto.fastcheckout.TransactionLog.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.TransactionLog.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp Updated = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fastcheckout.TransactionLog.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fastcheckout.TransactionLog} returns this
*/
proto.fastcheckout.TransactionLog.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.TransactionLog} returns this
 */
proto.fastcheckout.TransactionLog.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.TransactionLog.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.BankInfo.repeatedFields_ = [9,17,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.BankInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.BankInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.BankInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.BankInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankcode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    country: jspb.Message.getFieldWithDefault(msg, 4, 0),
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    logourl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    bankinteractionmethod: jspb.Message.getFieldWithDefault(msg, 7, 0),
    placementorder: jspb.Message.getFieldWithDefault(msg, 8, 0),
    bankcodessupportedList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    portalname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    fundtransferlimit: (f = msg.getFundtransferlimit()) && proto.fastcheckout.FundTransferLimit.toObject(includeInstance, f),
    fundtransferfee: (f = msg.getFundtransferfee()) && proto.fastcheckout.FundTransferFee.toObject(includeInstance, f),
    statementretrievalsupported: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    visasupported: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    pnglogourl: jspb.Message.getFieldWithDefault(msg, 15, ""),
    espaysupported: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    feesList: jspb.Message.toObjectList(msg.getFeesList(),
    proto.fastcheckout.Fee.toObject, includeInstance),
    bankinteractionmethodsList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.BankInfo}
 */
proto.fastcheckout.BankInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.BankInfo;
  return proto.fastcheckout.BankInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.BankInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.BankInfo}
 */
proto.fastcheckout.BankInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogourl(value);
      break;
    case 7:
      var value = /** @type {!proto.fastcheckout.BankInteractionMethod} */ (reader.readEnum());
      msg.setBankinteractionmethod(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementorder(value);
      break;
    case 9:
      var value = /** @type {!Array<!proto.fastcheckout.DestinationBankCode>} */ (reader.readPackedEnum());
      msg.setBankcodessupportedList(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPortalname(value);
      break;
    case 11:
      var value = new proto.fastcheckout.FundTransferLimit;
      reader.readMessage(value,proto.fastcheckout.FundTransferLimit.deserializeBinaryFromReader);
      msg.setFundtransferlimit(value);
      break;
    case 12:
      var value = new proto.fastcheckout.FundTransferFee;
      reader.readMessage(value,proto.fastcheckout.FundTransferFee.deserializeBinaryFromReader);
      msg.setFundtransferfee(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatementretrievalsupported(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisasupported(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPnglogourl(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEspaysupported(value);
      break;
    case 17:
      var value = new proto.fastcheckout.Fee;
      reader.readMessage(value,proto.fastcheckout.Fee.deserializeBinaryFromReader);
      msg.addFees(value);
      break;
    case 18:
      var value = /** @type {!Array<!proto.fastcheckout.BankInteractionMethod>} */ (reader.readPackedEnum());
      msg.setBankinteractionmethodsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.BankInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.BankInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.BankInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.BankInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLogourl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBankinteractionmethod();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPlacementorder();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getBankcodessupportedList();
  if (f.length > 0) {
    writer.writePackedEnum(
      9,
      f
    );
  }
  f = message.getPortalname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFundtransferlimit();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fastcheckout.FundTransferLimit.serializeBinaryToWriter
    );
  }
  f = message.getFundtransferfee();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.fastcheckout.FundTransferFee.serializeBinaryToWriter
    );
  }
  f = message.getStatementretrievalsupported();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getVisasupported();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getPnglogourl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getEspaysupported();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      proto.fastcheckout.Fee.serializeBinaryToWriter
    );
  }
  f = message.getBankinteractionmethodsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      18,
      f
    );
  }
};


/**
 * optional BankCode BankCode = 1;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.BankInfo.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.fastcheckout.BankInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Title = 3;
 * @return {string}
 */
proto.fastcheckout.BankInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional CountryISO3166 Country = 4;
 * @return {!proto.fastcheckout.CountryISO3166}
 */
proto.fastcheckout.BankInfo.prototype.getCountry = function() {
  return /** @type {!proto.fastcheckout.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.CountryISO3166} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool Enabled = 5;
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string LogoURL = 6;
 * @return {string}
 */
proto.fastcheckout.BankInfo.prototype.getLogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setLogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional BankInteractionMethod BankInteractionMethod = 7;
 * @return {!proto.fastcheckout.BankInteractionMethod}
 */
proto.fastcheckout.BankInfo.prototype.getBankinteractionmethod = function() {
  return /** @type {!proto.fastcheckout.BankInteractionMethod} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.fastcheckout.BankInteractionMethod} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setBankinteractionmethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 PlacementOrder = 8;
 * @return {number}
 */
proto.fastcheckout.BankInfo.prototype.getPlacementorder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setPlacementorder = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated DestinationBankCode BankCodesSupported = 9;
 * @return {!Array<!proto.fastcheckout.DestinationBankCode>}
 */
proto.fastcheckout.BankInfo.prototype.getBankcodessupportedList = function() {
  return /** @type {!Array<!proto.fastcheckout.DestinationBankCode>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<!proto.fastcheckout.DestinationBankCode>} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setBankcodessupportedList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.addBankcodessupported = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.clearBankcodessupportedList = function() {
  return this.setBankcodessupportedList([]);
};


/**
 * optional string PortalName = 10;
 * @return {string}
 */
proto.fastcheckout.BankInfo.prototype.getPortalname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setPortalname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional FundTransferLimit FundTransferLimit = 11;
 * @return {?proto.fastcheckout.FundTransferLimit}
 */
proto.fastcheckout.BankInfo.prototype.getFundtransferlimit = function() {
  return /** @type{?proto.fastcheckout.FundTransferLimit} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.FundTransferLimit, 11));
};


/**
 * @param {?proto.fastcheckout.FundTransferLimit|undefined} value
 * @return {!proto.fastcheckout.BankInfo} returns this
*/
proto.fastcheckout.BankInfo.prototype.setFundtransferlimit = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.clearFundtransferlimit = function() {
  return this.setFundtransferlimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.hasFundtransferlimit = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional FundTransferFee FundTransferFee = 12;
 * @return {?proto.fastcheckout.FundTransferFee}
 */
proto.fastcheckout.BankInfo.prototype.getFundtransferfee = function() {
  return /** @type{?proto.fastcheckout.FundTransferFee} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.FundTransferFee, 12));
};


/**
 * @param {?proto.fastcheckout.FundTransferFee|undefined} value
 * @return {!proto.fastcheckout.BankInfo} returns this
*/
proto.fastcheckout.BankInfo.prototype.setFundtransferfee = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.clearFundtransferfee = function() {
  return this.setFundtransferfee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.hasFundtransferfee = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool StatementRetrievalSupported = 13;
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.getStatementretrievalsupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setStatementretrievalsupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool VisaSupported = 14;
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.getVisasupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setVisasupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string PNGLogoURL = 15;
 * @return {string}
 */
proto.fastcheckout.BankInfo.prototype.getPnglogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setPnglogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool ESPaySupported = 16;
 * @return {boolean}
 */
proto.fastcheckout.BankInfo.prototype.getEspaysupported = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setEspaysupported = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * repeated Fee Fees = 17;
 * @return {!Array<!proto.fastcheckout.Fee>}
 */
proto.fastcheckout.BankInfo.prototype.getFeesList = function() {
  return /** @type{!Array<!proto.fastcheckout.Fee>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Fee, 17));
};


/**
 * @param {!Array<!proto.fastcheckout.Fee>} value
 * @return {!proto.fastcheckout.BankInfo} returns this
*/
proto.fastcheckout.BankInfo.prototype.setFeesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.fastcheckout.Fee=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Fee}
 */
proto.fastcheckout.BankInfo.prototype.addFees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.fastcheckout.Fee, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};


/**
 * repeated BankInteractionMethod BankInteractionMethods = 18;
 * @return {!Array<!proto.fastcheckout.BankInteractionMethod>}
 */
proto.fastcheckout.BankInfo.prototype.getBankinteractionmethodsList = function() {
  return /** @type {!Array<!proto.fastcheckout.BankInteractionMethod>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<!proto.fastcheckout.BankInteractionMethod>} value
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.setBankinteractionmethodsList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {!proto.fastcheckout.BankInteractionMethod} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.addBankinteractionmethods = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.BankInfo} returns this
 */
proto.fastcheckout.BankInfo.prototype.clearBankinteractionmethodsList = function() {
  return this.setBankinteractionmethodsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.DestinationBankInfo.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.DestinationBankInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.DestinationBankInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.DestinationBankInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationBankInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankcode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    country: jspb.Message.getFieldWithDefault(msg, 4, 0),
    placementorder: jspb.Message.getFieldWithDefault(msg, 5, 0),
    bankinteractionmethodsupportedList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.DestinationBankInfo}
 */
proto.fastcheckout.DestinationBankInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.DestinationBankInfo;
  return proto.fastcheckout.DestinationBankInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.DestinationBankInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.DestinationBankInfo}
 */
proto.fastcheckout.DestinationBankInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPlacementorder(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.fastcheckout.BankInteractionMethod>} */ (reader.readPackedEnum());
      msg.setBankinteractionmethodsupportedList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.DestinationBankInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.DestinationBankInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.DestinationBankInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationBankInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPlacementorder();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getBankinteractionmethodsupportedList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
};


/**
 * optional DestinationBankCode BankCode = 1;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Title = 3;
 * @return {string}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional CountryISO3166 Country = 4;
 * @return {!proto.fastcheckout.CountryISO3166}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getCountry = function() {
  return /** @type {!proto.fastcheckout.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.CountryISO3166} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 PlacementOrder = 5;
 * @return {number}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getPlacementorder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setPlacementorder = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated BankInteractionMethod BankInteractionMethodSupported = 6;
 * @return {!Array<!proto.fastcheckout.BankInteractionMethod>}
 */
proto.fastcheckout.DestinationBankInfo.prototype.getBankinteractionmethodsupportedList = function() {
  return /** @type {!Array<!proto.fastcheckout.BankInteractionMethod>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.fastcheckout.BankInteractionMethod>} value
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.setBankinteractionmethodsupportedList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.fastcheckout.BankInteractionMethod} value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.addBankinteractionmethodsupported = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.DestinationBankInfo} returns this
 */
proto.fastcheckout.DestinationBankInfo.prototype.clearBankinteractionmethodsupportedList = function() {
  return this.setBankinteractionmethodsupportedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.FundTransferLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.FundTransferLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.FundTransferLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
    cur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    intrabank: (f = msg.getIntrabank()) && proto.fastcheckout.Limits.toObject(includeInstance, f),
    interbank: (f = msg.getInterbank()) && proto.fastcheckout.Limits.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.FundTransferLimit}
 */
proto.fastcheckout.FundTransferLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.FundTransferLimit;
  return proto.fastcheckout.FundTransferLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.FundTransferLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.FundTransferLimit}
 */
proto.fastcheckout.FundTransferLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setCur(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Limits;
      reader.readMessage(value,proto.fastcheckout.Limits.deserializeBinaryFromReader);
      msg.setIntrabank(value);
      break;
    case 3:
      var value = new proto.fastcheckout.Limits;
      reader.readMessage(value,proto.fastcheckout.Limits.deserializeBinaryFromReader);
      msg.setInterbank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.FundTransferLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.FundTransferLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.FundTransferLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCur();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIntrabank();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fastcheckout.Limits.serializeBinaryToWriter
    );
  }
  f = message.getInterbank();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.fastcheckout.Limits.serializeBinaryToWriter
    );
  }
};


/**
 * optional CurrencyISO4217 Cur = 1;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.FundTransferLimit.prototype.getCur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.FundTransferLimit} returns this
 */
proto.fastcheckout.FundTransferLimit.prototype.setCur = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Limits Intrabank = 2;
 * @return {?proto.fastcheckout.Limits}
 */
proto.fastcheckout.FundTransferLimit.prototype.getIntrabank = function() {
  return /** @type{?proto.fastcheckout.Limits} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Limits, 2));
};


/**
 * @param {?proto.fastcheckout.Limits|undefined} value
 * @return {!proto.fastcheckout.FundTransferLimit} returns this
*/
proto.fastcheckout.FundTransferLimit.prototype.setIntrabank = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferLimit} returns this
 */
proto.fastcheckout.FundTransferLimit.prototype.clearIntrabank = function() {
  return this.setIntrabank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferLimit.prototype.hasIntrabank = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Limits Interbank = 3;
 * @return {?proto.fastcheckout.Limits}
 */
proto.fastcheckout.FundTransferLimit.prototype.getInterbank = function() {
  return /** @type{?proto.fastcheckout.Limits} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Limits, 3));
};


/**
 * @param {?proto.fastcheckout.Limits|undefined} value
 * @return {!proto.fastcheckout.FundTransferLimit} returns this
*/
proto.fastcheckout.FundTransferLimit.prototype.setInterbank = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.FundTransferLimit} returns this
 */
proto.fastcheckout.FundTransferLimit.prototype.clearInterbank = function() {
  return this.setInterbank(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.FundTransferLimit.prototype.hasInterbank = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Limits.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Limits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Limits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Limits.toObject = function(includeInstance, msg) {
  var f, obj = {
    min: jspb.Message.getFieldWithDefault(msg, 1, ""),
    max: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Limits}
 */
proto.fastcheckout.Limits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Limits;
  return proto.fastcheckout.Limits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Limits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Limits}
 */
proto.fastcheckout.Limits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Limits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Limits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Limits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Limits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMax();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Min = 1;
 * @return {string}
 */
proto.fastcheckout.Limits.prototype.getMin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Limits} returns this
 */
proto.fastcheckout.Limits.prototype.setMin = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Max = 2;
 * @return {string}
 */
proto.fastcheckout.Limits.prototype.getMax = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Limits} returns this
 */
proto.fastcheckout.Limits.prototype.setMax = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.FundTransferFee.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.FundTransferFee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.FundTransferFee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferFee.toObject = function(includeInstance, msg) {
  var f, obj = {
    cur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    idonlinetransferlimit: jspb.Message.getFieldWithDefault(msg, 2, ""),
    idonlinetransferfee: jspb.Message.getFieldWithDefault(msg, 3, ""),
    idllgtransferlimit: jspb.Message.getFieldWithDefault(msg, 4, ""),
    idllgtransferfee: jspb.Message.getFieldWithDefault(msg, 5, ""),
    idrtgstransferfee: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phinstapaytransferlimit: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phinstapaytransferfee: jspb.Message.getFieldWithDefault(msg, 8, ""),
    phpesonettransferfee: jspb.Message.getFieldWithDefault(msg, 9, ""),
    intrabanktransferfee: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.FundTransferFee}
 */
proto.fastcheckout.FundTransferFee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.FundTransferFee;
  return proto.fastcheckout.FundTransferFee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.FundTransferFee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.FundTransferFee}
 */
proto.fastcheckout.FundTransferFee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setCur(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdonlinetransferlimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdonlinetransferfee(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdllgtransferlimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdllgtransferfee(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdrtgstransferfee(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhinstapaytransferlimit(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhinstapaytransferfee(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhpesonettransferfee(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntrabanktransferfee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.FundTransferFee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.FundTransferFee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.FundTransferFee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.FundTransferFee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCur();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIdonlinetransferlimit();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIdonlinetransferfee();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdllgtransferlimit();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIdllgtransferfee();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIdrtgstransferfee();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhinstapaytransferlimit();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhinstapaytransferfee();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPhpesonettransferfee();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIntrabanktransferfee();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional CurrencyISO4217 Cur = 1;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.FundTransferFee.prototype.getCur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setCur = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string IDOnlineTransferLimit = 2;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIdonlinetransferlimit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIdonlinetransferlimit = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string IDOnlineTransferFee = 3;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIdonlinetransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIdonlinetransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string IDLLGTransferLimit = 4;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIdllgtransferlimit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIdllgtransferlimit = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string IDLLGTransferFee = 5;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIdllgtransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIdllgtransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string IDRTGSTransferFee = 6;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIdrtgstransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIdrtgstransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string PHInstapayTransferLimit = 7;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getPhinstapaytransferlimit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setPhinstapaytransferlimit = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string PHInstapayTransferFee = 8;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getPhinstapaytransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setPhinstapaytransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string PHPesonetTransferFee = 9;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getPhpesonettransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setPhpesonettransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string IntrabankTransferFee = 10;
 * @return {string}
 */
proto.fastcheckout.FundTransferFee.prototype.getIntrabanktransferfee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.FundTransferFee} returns this
 */
proto.fastcheckout.FundTransferFee.prototype.setIntrabanktransferfee = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Fee.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Fee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Fee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Fee.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: (f = msg.getAmount()) && proto.fastcheckout.Amount.toObject(includeInstance, f),
    bankinteractionmethod: jspb.Message.getFieldWithDefault(msg, 2, 0),
    destinationbank: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Fee}
 */
proto.fastcheckout.Fee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Fee;
  return proto.fastcheckout.Fee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Fee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Fee}
 */
proto.fastcheckout.Fee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {!proto.fastcheckout.BankInteractionMethod} */ (reader.readEnum());
      msg.setBankinteractionmethod(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setDestinationbank(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Fee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Fee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Fee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Fee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
  f = message.getBankinteractionmethod();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDestinationbank();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional Amount Amount = 1;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.Fee.prototype.getAmount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 1));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.Fee} returns this
*/
proto.fastcheckout.Fee.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Fee} returns this
 */
proto.fastcheckout.Fee.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Fee.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BankInteractionMethod BankInteractionMethod = 2;
 * @return {!proto.fastcheckout.BankInteractionMethod}
 */
proto.fastcheckout.Fee.prototype.getBankinteractionmethod = function() {
  return /** @type {!proto.fastcheckout.BankInteractionMethod} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fastcheckout.BankInteractionMethod} value
 * @return {!proto.fastcheckout.Fee} returns this
 */
proto.fastcheckout.Fee.prototype.setBankinteractionmethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DestinationBankCode DestinationBank = 3;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.fastcheckout.Fee.prototype.getDestinationbank = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.fastcheckout.Fee} returns this
 */
proto.fastcheckout.Fee.prototype.setDestinationbank = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Amount.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Amount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Amount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Amount.toObject = function(includeInstance, msg) {
  var f, obj = {
    cur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    num: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Amount}
 */
proto.fastcheckout.Amount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Amount;
  return proto.fastcheckout.Amount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Amount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Amount}
 */
proto.fastcheckout.Amount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setCur(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Amount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Amount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Amount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Amount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCur();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNum();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CurrencyISO4217 Cur = 1;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.Amount.prototype.getCur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.Amount} returns this
 */
proto.fastcheckout.Amount.prototype.setCur = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Num = 2;
 * @return {string}
 */
proto.fastcheckout.Amount.prototype.getNum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Amount} returns this
 */
proto.fastcheckout.Amount.prototype.setNum = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.AmountBreakdown.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.AmountBreakdown.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.AmountBreakdown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AmountBreakdown.toObject = function(includeInstance, msg) {
  var f, obj = {
    adminfee: (f = msg.getAdminfee()) && proto.fastcheckout.Amount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.AmountBreakdown}
 */
proto.fastcheckout.AmountBreakdown.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.AmountBreakdown;
  return proto.fastcheckout.AmountBreakdown.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.AmountBreakdown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.AmountBreakdown}
 */
proto.fastcheckout.AmountBreakdown.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAdminfee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.AmountBreakdown.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.AmountBreakdown.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.AmountBreakdown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AmountBreakdown.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdminfee();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
};


/**
 * optional Amount AdminFee = 1;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.AmountBreakdown.prototype.getAdminfee = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 1));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.AmountBreakdown} returns this
*/
proto.fastcheckout.AmountBreakdown.prototype.setAdminfee = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.AmountBreakdown} returns this
 */
proto.fastcheckout.AmountBreakdown.prototype.clearAdminfee = function() {
  return this.setAdminfee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.AmountBreakdown.prototype.hasAdminfee = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.AccountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.AccountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.AccountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bankcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    identifier: jspb.Message.getFieldWithDefault(msg, 4, ""),
    holdername: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.AccountInfo}
 */
proto.fastcheckout.AccountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.AccountInfo;
  return proto.fastcheckout.AccountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.AccountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.AccountInfo}
 */
proto.fastcheckout.AccountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.AccountInfoType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldername(value);
      break;
    case 6:
      var value = /** @type {!proto.fastcheckout.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.AccountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.AccountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.AccountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.AccountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHoldername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional AccountInfoType Type = 1;
 * @return {!proto.fastcheckout.AccountInfoType}
 */
proto.fastcheckout.AccountInfo.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.AccountInfoType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.AccountInfoType} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BankCode BankCode = 2;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.fastcheckout.AccountInfo.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string AccountNumber = 3;
 * @return {string}
 */
proto.fastcheckout.AccountInfo.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Identifier = 4;
 * @return {string}
 */
proto.fastcheckout.AccountInfo.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string HolderName = 5;
 * @return {string}
 */
proto.fastcheckout.AccountInfo.prototype.getHoldername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setHoldername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional CountryISO3166 Country = 6;
 * @return {!proto.fastcheckout.CountryISO3166}
 */
proto.fastcheckout.AccountInfo.prototype.getCountry = function() {
  return /** @type {!proto.fastcheckout.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.fastcheckout.CountryISO3166} value
 * @return {!proto.fastcheckout.AccountInfo} returns this
 */
proto.fastcheckout.AccountInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.DestinationAccountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.DestinationAccountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationAccountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bankcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    accountnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    identifier: jspb.Message.getFieldWithDefault(msg, 4, ""),
    holdername: jspb.Message.getFieldWithDefault(msg, 5, ""),
    holderfirstname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    holdermiddlename: jspb.Message.getFieldWithDefault(msg, 7, ""),
    holderlastname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    emailaddress: jspb.Message.getFieldWithDefault(msg, 9, ""),
    mobilecountrycode: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mobilenumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 12, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 13, ""),
    city: jspb.Message.getFieldWithDefault(msg, 14, ""),
    state: jspb.Message.getFieldWithDefault(msg, 15, ""),
    country: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.DestinationAccountInfo}
 */
proto.fastcheckout.DestinationAccountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.DestinationAccountInfo;
  return proto.fastcheckout.DestinationAccountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.DestinationAccountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.DestinationAccountInfo}
 */
proto.fastcheckout.DestinationAccountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.AccountInfoType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderfirstname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldermiddlename(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderlastname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailaddress(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilecountrycode(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilenumber(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.DestinationAccountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.DestinationAccountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.DestinationAccountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHoldername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHolderfirstname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHoldermiddlename();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHolderlastname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmailaddress();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMobilecountrycode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMobilenumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional AccountInfoType Type = 1;
 * @return {!proto.fastcheckout.AccountInfoType}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getType = function() {
  return /** @type {!proto.fastcheckout.AccountInfoType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.AccountInfoType} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional DestinationBankCode BankCode = 2;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string AccountNumber = 3;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Identifier = 4;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string HolderName = 5;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getHoldername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setHoldername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string HolderFirstName = 6;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getHolderfirstname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setHolderfirstname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string HolderMiddleName = 7;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getHoldermiddlename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setHoldermiddlename = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string HolderLastName = 8;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getHolderlastname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setHolderlastname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string EmailAddress = 9;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getEmailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setEmailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string MobileCountryCode = 10;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getMobilecountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setMobilecountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string MobileNumber = 11;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getMobilenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setMobilenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string AddressLine1 = 12;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string AddressLine2 = 13;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string City = 14;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string State = 15;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string Country = 16;
 * @return {string}
 */
proto.fastcheckout.DestinationAccountInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.DestinationAccountInfo} returns this
 */
proto.fastcheckout.DestinationAccountInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Credential.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Credential.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Credential} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Credential.toObject = function(includeInstance, msg) {
  var f, obj = {
    credentialtype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    identifier: jspb.Message.getFieldWithDefault(msg, 2, ""),
    secret: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Credential}
 */
proto.fastcheckout.Credential.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Credential;
  return proto.fastcheckout.Credential.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Credential} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Credential}
 */
proto.fastcheckout.Credential.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.CredentialType} */ (reader.readEnum());
      msg.setCredentialtype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifier(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Credential.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Credential.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Credential} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Credential.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCredentialtype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIdentifier();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional CredentialType CredentialType = 1;
 * @return {!proto.fastcheckout.CredentialType}
 */
proto.fastcheckout.Credential.prototype.getCredentialtype = function() {
  return /** @type {!proto.fastcheckout.CredentialType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.CredentialType} value
 * @return {!proto.fastcheckout.Credential} returns this
 */
proto.fastcheckout.Credential.prototype.setCredentialtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Identifier = 2;
 * @return {string}
 */
proto.fastcheckout.Credential.prototype.getIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Credential} returns this
 */
proto.fastcheckout.Credential.prototype.setIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Secret = 3;
 * @return {string}
 */
proto.fastcheckout.Credential.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Credential} returns this
 */
proto.fastcheckout.Credential.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Hash = 4;
 * @return {string}
 */
proto.fastcheckout.Credential.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Credential} returns this
 */
proto.fastcheckout.Credential.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
    fname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    lname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phone: jspb.Message.getFieldWithDefault(msg, 6, ""),
    customerid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    address: (f = msg.getAddress()) && proto.fastcheckout.Address.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Customer}
 */
proto.fastcheckout.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Customer;
  return proto.fastcheckout.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Customer}
 */
proto.fastcheckout.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomerid(value);
      break;
    case 8:
      var value = new proto.fastcheckout.Address;
      reader.readMessage(value,proto.fastcheckout.Address.deserializeBinaryFromReader);
      msg.setAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomerid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddress();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.fastcheckout.Address.serializeBinaryToWriter
    );
  }
};


/**
 * optional string FName = 1;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getFname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setFname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string LName = 2;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getLname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setLname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string MName = 3;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getMname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setMname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Mobile = 5;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Phone = 6;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string CustomerID = 7;
 * @return {string}
 */
proto.fastcheckout.Customer.prototype.getCustomerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.setCustomerid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Address Address = 8;
 * @return {?proto.fastcheckout.Address}
 */
proto.fastcheckout.Customer.prototype.getAddress = function() {
  return /** @type{?proto.fastcheckout.Address} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Address, 8));
};


/**
 * @param {?proto.fastcheckout.Address|undefined} value
 * @return {!proto.fastcheckout.Customer} returns this
*/
proto.fastcheckout.Customer.prototype.setAddress = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.Customer} returns this
 */
proto.fastcheckout.Customer.prototype.clearAddress = function() {
  return this.setAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.Customer.prototype.hasAddress = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
    line1: jspb.Message.getFieldWithDefault(msg, 1, ""),
    line2: jspb.Message.getFieldWithDefault(msg, 2, ""),
    city: jspb.Message.getFieldWithDefault(msg, 3, ""),
    province: jspb.Message.getFieldWithDefault(msg, 4, ""),
    zipcode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Address}
 */
proto.fastcheckout.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Address;
  return proto.fastcheckout.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Address}
 */
proto.fastcheckout.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine1(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLine2(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipcode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLine1();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLine2();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getZipcode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string Line1 = 1;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Line2 = 2;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string City = 3;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Province = 4;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ZipCode = 5;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getZipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setZipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Country = 6;
 * @return {string}
 */
proto.fastcheckout.Address.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Address} returns this
 */
proto.fastcheckout.Address.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fastcheckout.InvoiceDetails.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.InvoiceDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.InvoiceDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.InvoiceDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.InvoiceDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    lineitemsList: jspb.Message.toObjectList(msg.getLineitemsList(),
    proto.fastcheckout.LineItem.toObject, includeInstance),
    chargesList: jspb.Message.toObjectList(msg.getChargesList(),
    proto.fastcheckout.Charge.toObject, includeInstance),
    discountList: jspb.Message.toObjectList(msg.getDiscountList(),
    proto.fastcheckout.Discount.toObject, includeInstance),
    amount: (f = msg.getAmount()) && proto.fastcheckout.Amount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.InvoiceDetails}
 */
proto.fastcheckout.InvoiceDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.InvoiceDetails;
  return proto.fastcheckout.InvoiceDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.InvoiceDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.InvoiceDetails}
 */
proto.fastcheckout.InvoiceDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fastcheckout.LineItem;
      reader.readMessage(value,proto.fastcheckout.LineItem.deserializeBinaryFromReader);
      msg.addLineitems(value);
      break;
    case 2:
      var value = new proto.fastcheckout.Charge;
      reader.readMessage(value,proto.fastcheckout.Charge.deserializeBinaryFromReader);
      msg.addCharges(value);
      break;
    case 3:
      var value = new proto.fastcheckout.Discount;
      reader.readMessage(value,proto.fastcheckout.Discount.deserializeBinaryFromReader);
      msg.addDiscount(value);
      break;
    case 4:
      var value = new proto.fastcheckout.Amount;
      reader.readMessage(value,proto.fastcheckout.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.InvoiceDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.InvoiceDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.InvoiceDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.InvoiceDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLineitemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fastcheckout.LineItem.serializeBinaryToWriter
    );
  }
  f = message.getChargesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.fastcheckout.Charge.serializeBinaryToWriter
    );
  }
  f = message.getDiscountList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fastcheckout.Discount.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.fastcheckout.Amount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LineItem LineItems = 1;
 * @return {!Array<!proto.fastcheckout.LineItem>}
 */
proto.fastcheckout.InvoiceDetails.prototype.getLineitemsList = function() {
  return /** @type{!Array<!proto.fastcheckout.LineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.LineItem, 1));
};


/**
 * @param {!Array<!proto.fastcheckout.LineItem>} value
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
*/
proto.fastcheckout.InvoiceDetails.prototype.setLineitemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fastcheckout.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.LineItem}
 */
proto.fastcheckout.InvoiceDetails.prototype.addLineitems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fastcheckout.LineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
 */
proto.fastcheckout.InvoiceDetails.prototype.clearLineitemsList = function() {
  return this.setLineitemsList([]);
};


/**
 * repeated Charge Charges = 2;
 * @return {!Array<!proto.fastcheckout.Charge>}
 */
proto.fastcheckout.InvoiceDetails.prototype.getChargesList = function() {
  return /** @type{!Array<!proto.fastcheckout.Charge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Charge, 2));
};


/**
 * @param {!Array<!proto.fastcheckout.Charge>} value
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
*/
proto.fastcheckout.InvoiceDetails.prototype.setChargesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.fastcheckout.Charge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Charge}
 */
proto.fastcheckout.InvoiceDetails.prototype.addCharges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fastcheckout.Charge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
 */
proto.fastcheckout.InvoiceDetails.prototype.clearChargesList = function() {
  return this.setChargesList([]);
};


/**
 * repeated Discount Discount = 3;
 * @return {!Array<!proto.fastcheckout.Discount>}
 */
proto.fastcheckout.InvoiceDetails.prototype.getDiscountList = function() {
  return /** @type{!Array<!proto.fastcheckout.Discount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fastcheckout.Discount, 3));
};


/**
 * @param {!Array<!proto.fastcheckout.Discount>} value
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
*/
proto.fastcheckout.InvoiceDetails.prototype.setDiscountList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fastcheckout.Discount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fastcheckout.Discount}
 */
proto.fastcheckout.InvoiceDetails.prototype.addDiscount = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fastcheckout.Discount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
 */
proto.fastcheckout.InvoiceDetails.prototype.clearDiscountList = function() {
  return this.setDiscountList([]);
};


/**
 * optional Amount Amount = 4;
 * @return {?proto.fastcheckout.Amount}
 */
proto.fastcheckout.InvoiceDetails.prototype.getAmount = function() {
  return /** @type{?proto.fastcheckout.Amount} */ (
    jspb.Message.getWrapperField(this, proto.fastcheckout.Amount, 4));
};


/**
 * @param {?proto.fastcheckout.Amount|undefined} value
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
*/
proto.fastcheckout.InvoiceDetails.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fastcheckout.InvoiceDetails} returns this
 */
proto.fastcheckout.InvoiceDetails.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fastcheckout.InvoiceDetails.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.LineItem.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.LineItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.LineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.LineItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    unitprice: jspb.Message.getFieldWithDefault(msg, 3, ""),
    pricecur: jspb.Message.getFieldWithDefault(msg, 4, 0),
    quantity: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.LineItem}
 */
proto.fastcheckout.LineItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.LineItem;
  return proto.fastcheckout.LineItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.LineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.LineItem}
 */
proto.fastcheckout.LineItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitprice(value);
      break;
    case 4:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setPricecur(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.LineItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.LineItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.LineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.LineItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUnitprice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPricecur();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string ItemName = 1;
 * @return {string}
 */
proto.fastcheckout.LineItem.prototype.getItemname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LineItem} returns this
 */
proto.fastcheckout.LineItem.prototype.setItemname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ItemID = 2;
 * @return {string}
 */
proto.fastcheckout.LineItem.prototype.getItemid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LineItem} returns this
 */
proto.fastcheckout.LineItem.prototype.setItemid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UnitPrice = 3;
 * @return {string}
 */
proto.fastcheckout.LineItem.prototype.getUnitprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.LineItem} returns this
 */
proto.fastcheckout.LineItem.prototype.setUnitprice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional CurrencyISO4217 PriceCur = 4;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.LineItem.prototype.getPricecur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.LineItem} returns this
 */
proto.fastcheckout.LineItem.prototype.setPricecur = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 Quantity = 5;
 * @return {number}
 */
proto.fastcheckout.LineItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fastcheckout.LineItem} returns this
 */
proto.fastcheckout.LineItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Charge.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Charge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Charge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Charge.toObject = function(includeInstance, msg) {
  var f, obj = {
    chargetype: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chargeamount: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chargecur: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Charge}
 */
proto.fastcheckout.Charge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Charge;
  return proto.fastcheckout.Charge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Charge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Charge}
 */
proto.fastcheckout.Charge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargetype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeamount(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setChargecur(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Charge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Charge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Charge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Charge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargetype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChargeamount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChargecur();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string ChargeType = 1;
 * @return {string}
 */
proto.fastcheckout.Charge.prototype.getChargetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Charge} returns this
 */
proto.fastcheckout.Charge.prototype.setChargetype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ChargeAmount = 2;
 * @return {string}
 */
proto.fastcheckout.Charge.prototype.getChargeamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Charge} returns this
 */
proto.fastcheckout.Charge.prototype.setChargeamount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CurrencyISO4217 ChargeCur = 3;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.Charge.prototype.getChargecur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.Charge} returns this
 */
proto.fastcheckout.Charge.prototype.setChargecur = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fastcheckout.Discount.prototype.toObject = function(opt_includeInstance) {
  return proto.fastcheckout.Discount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fastcheckout.Discount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Discount.toObject = function(includeInstance, msg) {
  var f, obj = {
    discounttype: jspb.Message.getFieldWithDefault(msg, 1, ""),
    discountamount: jspb.Message.getFieldWithDefault(msg, 2, ""),
    discountcur: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fastcheckout.Discount}
 */
proto.fastcheckout.Discount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fastcheckout.Discount;
  return proto.fastcheckout.Discount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fastcheckout.Discount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fastcheckout.Discount}
 */
proto.fastcheckout.Discount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscounttype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiscountamount(value);
      break;
    case 3:
      var value = /** @type {!proto.fastcheckout.CurrencyISO4217} */ (reader.readEnum());
      msg.setDiscountcur(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fastcheckout.Discount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fastcheckout.Discount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fastcheckout.Discount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fastcheckout.Discount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscounttype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDiscountamount();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDiscountcur();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string DiscountType = 1;
 * @return {string}
 */
proto.fastcheckout.Discount.prototype.getDiscounttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Discount} returns this
 */
proto.fastcheckout.Discount.prototype.setDiscounttype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string DiscountAmount = 2;
 * @return {string}
 */
proto.fastcheckout.Discount.prototype.getDiscountamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fastcheckout.Discount} returns this
 */
proto.fastcheckout.Discount.prototype.setDiscountamount = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CurrencyISO4217 DiscountCur = 3;
 * @return {!proto.fastcheckout.CurrencyISO4217}
 */
proto.fastcheckout.Discount.prototype.getDiscountcur = function() {
  return /** @type {!proto.fastcheckout.CurrencyISO4217} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.fastcheckout.CurrencyISO4217} value
 * @return {!proto.fastcheckout.Discount} returns this
 */
proto.fastcheckout.Discount.prototype.setDiscountcur = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.fastcheckout.DestinationBankCode = {
  UNKNOWN_DESTINATION_BANK: 0,
  DUMMY_BANK_DESTINATION: 1,
  ID_BCA: 2,
  ID_BCA_SYR: 3,
  ID_BNI: 4,
  ID_BNI_SYR: 5,
  ID_BRI: 6,
  ID_BRI_SYR: 7,
  ID_MANDIRI: 8,
  ID_MANDIRI_SYR: 9,
  ID_BTN: 10,
  ID_BTN_SYR: 11,
  ID_PERMATA: 12,
  ID_PERMATA_SYR: 13,
  ID_DNMN: 14,
  ID_DNMN_SYR: 15,
  ID_BTPN: 16,
  ID_BTPN_SYR: 17,
  ID_OCBC: 18,
  ID_OCBC_SYR: 19,
  ID_MAYBANK: 20,
  ID_MAYBANK_SYR: 21,
  ID_CIMB: 22,
  ID_CIMB_SYR: 23,
  ID_PAN: 24,
  ID_PAN_SYR: 25,
  ID_MEGA: 26,
  ID_MEGA_SYR: 27,
  ID_BKP: 28,
  ID_BKP_SYR: 29,
  ID_DKI: 30,
  ID_DKI_SYR: 31,
  ID_BJB: 32,
  ID_BJB_SYR: 33,
  ID_JATIM: 34,
  ID_JATIM_SYR: 35,
  ID_HSBC: 36,
  ID_DBS: 37,
  ID_STAN: 38,
  ID_UOB: 39,
  ID_CITI: 40,
  PH_BDO: 41,
  PH_BPI: 42,
  PH_BPIF: 43,
  PH_METRO: 44,
  PH_PNB: 45,
  PH_PNBS: 46,
  PH_RCBC: 47,
  PH_RCBCS: 48,
  PH_SB: 49,
  PH_SBS: 50,
  PH_UB: 51,
  PH_CLRB: 52,
  PH_GXI: 53,
  PH_GBY: 54,
  PH_LBP: 55,
  PH_PMP: 56,
  PH_PSB: 57,
  PH_RSB: 58,
  PH_CB: 59,
  PH_CBS: 60,
  TH_KBANK: 61,
  DUMMY_INTERBANK_DESTINATION: 62,
  PH_ALLBANK: 63,
  PH_SUNSB: 64,
  PH_STERLING: 65,
  PH_MBSMB: 66,
  PH_AUB: 67,
  PH_BOC: 68,
  PH_MAYBANK: 69,
  PH_PBCOM: 70,
  PH_CTBC: 71,
  PH_EWB: 72,
  PH_EQB: 73,
  PH_OMNIPAY: 74,
  PH_UCPB: 75,
  PH_PHILTRUST: 76,
  PH_WDB: 77,
  PH_DUNGGANUN: 78,
  PH_UCPBSB: 79,
  PH_ISLA: 80,
  PH_PRBC: 81,
  PH_PBB: 82,
  PH_PVB: 83,
  PH_YSBP: 84,
  PH_MABUHAY: 85,
  PH_CTBCPH: 86,
  PH_ING: 87,
  PH_QCRB: 88,
  PH_BDONB: 89,
  PH_EWBRB: 90,
  TH_SCB: 91,
  PH_STAN: 92,
  PH_HSBC: 93,
  PH_CITI: 94,
  PH_BOA: 95,
  PH_UOB: 96,
  PH_TOKYO: 97,
  PH_MICB: 98,
  PH_DBP: 99,
  PH_ANZ: 100,
  PH_KEB_HANA: 101,
  PH_CHASE: 102,
  PH_FCB: 103,
  PH_MIZUHO: 104,
  PH_DBS: 105,
  PH_BBL: 106,
  PH_CHINA: 107,
  PH_SUMITOMO_MITSUI: 108,
  PH_SHINHAN: 109,
  PH_IBK: 110,
  PH_STARPAY: 111,
  PH_QUEENBANK: 112,
  PH_INNOVATIVE_BANK: 113,
  PH_AAIIB: 114,
  PH_PRODUCERSSBC: 115,
  PH_BPI_BANKO: 116,
  PH_CIMB: 117,
  PH_BANKFLORIDAPH: 118,
  PH_GUINOBATAN: 119,
  PH_HSBCSB: 120,
  PH_CAMALIG: 121,
  PH_COUNTRY_BUILDERS: 122,
  PH_RANGAY_BANK: 123,
  PH_COINSPH: 124,
  PH_CARDBANK: 125,
  ID_ESP: 126,
  PH_NETBANK: 127
};

/**
 * @enum {number}
 */
proto.fastcheckout.AccountType = {
  UNKNOWN: 0,
  CHECKING: 1,
  SAVINGS: 2,
  JOINT: 3,
  PAYROLL: 4,
  CORPORATE: 5,
  INVESTMENT: 6,
  CREDITCARD: 7
};

/**
 * @enum {number}
 */
proto.fastcheckout.TransactionType = {
  UNKNOWN_TYPE: 0,
  CREDIT: 1,
  DEBIT: 2
};

/**
 * @enum {number}
 */
proto.fastcheckout.TransactionStatus = {
  UNKNOWN_STATUS: 0,
  SUCCESS: 1,
  PENDING: 2
};

/**
 * @enum {number}
 */
proto.fastcheckout.StatementStatus = {
  STATUS_UNKNOWN: 0,
  PENDING_STATUS: 1,
  FAILED: 2,
  COMPLETED: 3,
  NOTIFIED: 4,
  RECEIVED: 5,
  CANCELLED_STATUS: 6,
  INACTIVATED: 7,
  PURGED: 8,
  RECORDS_AVAILABLE: 9,
  INITIATED_STATUS: 10,
  NO_ACCOUNT: 11,
  RECONCILIATION_COMPLETED: 12,
  RECONCILIATION_NEW_TRANSACTION: 13,
  RECONCILIATION_DISABLED: 14
};

/**
 * @enum {number}
 */
proto.fastcheckout.ChallengeType = {
  TEXT: 0,
  IMAGE: 1,
  IN_APP: 2,
  SMS: 3,
  MGENCODE: 4,
  HYBRID: 5,
  PIN: 6,
  USER_ACTION: 7,
  MULTIPLE_TFA: 8,
  EMAIL_OTP: 9
};

/**
 * @enum {number}
 */
proto.fastcheckout.Via = {
  UNKNOWN_VIA: 0,
  INTRABANK: 1,
  IDONLINE: 2,
  IDLLG: 3,
  IDRTGS: 4,
  PHINSTAPAY: 5,
  PHPESONET: 6,
  VISANET: 7
};

/**
 * @enum {number}
 */
proto.fastcheckout.StatementTaskStatus = {
  STATUS_PENDING: 0,
  TFA_AWAIT: 1,
  INITIATED: 2
};

/**
 * @enum {number}
 */
proto.fastcheckout.StatementSubStatus = {
  UNKNOWN_STATEMENTSUBSTATUS: 0,
  SUBSTATUS_INITIATED: 1,
  SUBSTATUS_LOGIN_ERROR: 2,
  SUBSTATUS_AWAITING_LOGIN: 3,
  SUBSTATUS_AWAITING_TFA: 4,
  SUBSTATUS_COMPLETED: 5,
  SUBSTATUS_BLOCKED: 6,
  SUBSTATUS_INPROGRESS: 7,
  SUBSTATUS_INVALID_TFA: 8,
  SUBSTATUS_NO_TFA_PROVIDED: 9,
  SUBSTATUS_SYSTEM_UNAVAILABLE: 10,
  SUBSTATUS_ERROR: 11,
  SUBSTATUS_CANCELLED: 12,
  SUBSTATUS_INACTIVATED: 13,
  SUBSTATUS_PURGED: 14,
  SUBSTATUS_RECORDS_AVAILABLE: 15,
  SUBSTATUS_TFA_OPTIONAL: 16,
  SUBSTATUS_INCOME_AVAILABLE: 17,
  SUBSTATUS_PERMISSION_REQUIRED: 18,
  SUBSTATUS_OTP_EXPIRED: 19,
  SUBSTATUS_WRONG_PDF_FORMAT: 20,
  SUBSTATUS_REFUSE_CONSENT: 21
};

/**
 * @enum {number}
 */
proto.fastcheckout.FundTransferTaskStatus = {
  TRANSFERSTATUS_CREATED: 0,
  TRANSFERSTATUS_TFA_AWAIT: 1,
  TRANSFERSTATUS_COMPLETED: 2,
  TRANSFERSTATUS_ERROR: 3,
  TRANSFERSTATUS_LOGIN_ERROR: 4,
  TRANSFERSTATUS_INVOICE_CREATED: 5,
  TRANSFERSTATUS_AWAITING_LOGIN: 6,
  TRANSFERSTATUS_AWAITING_LOGIN_TFA: 7,
  TRANSFERSTATUS_AWAITING_ACCOUNT_SELECT: 8,
  TRANSFERSTATUS_AWAITING_TRANSFER_TFA: 9,
  TRANSFERSTATUS_IN_PROGRESS: 10,
  TRANSFERSTATUS_EXPIRED: 11,
  TRANSFERSTATUS_FLAGGED: 12,
  TRANSFERSTATUS_CANCELLED: 13,
  TRANSFERSTATUS_DENIED: 14,
  TRANSFERSTATUS_FAILED: 15
};

/**
 * @enum {number}
 */
proto.fastcheckout.SettlementResponseCode = {
  UNKNOWN_CODE: 0,
  GR001: 1,
  GR011: 2,
  GR032: 3,
  GR036: 4,
  GR092: 5,
  RM021: 6,
  RM022: 7,
  RM036: 8
};

/**
 * @enum {number}
 */
proto.fastcheckout.FetchAccountsTaskStatus = {
  TASKSTATUS_CREATED: 0,
  TASKSTATUS_TFA_AWAIT: 1,
  TASKSTATUS_COMPLETED: 2,
  TASKSTATUS_ERROR: 3,
  TASKSTATUS_LOGIN_ERROR: 4,
  TASKSTATUS_TFA_OPTIONAL: 5,
  TASKSTATUS_LOGIN_DONE_WITHOUT_TFA: 6,
  TASKSTATUS_CANCELLED: 7
};

/**
 * @enum {number}
 */
proto.fastcheckout.CallbackURLStatus = {
  UNKNOWN_URLSTATUS: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  ACTIVE_UNPROXIED: 3
};

/**
 * @enum {number}
 */
proto.fastcheckout.Language = {
  UNKNOWN_LANGUAGE: 0,
  EN_LANGUAGE: 1,
  ID_LANGUAGE: 2,
  TH_LANGUAGE: 3
};

/**
 * @enum {number}
 */
proto.fastcheckout.ReportType = {
  UNKNOWN_REPORTTYPE: 0,
  EOD_REPORTTYPE: 1
};

/**
 * @enum {number}
 */
proto.fastcheckout.ReportStatus = {
  UNKNOWN_REPORTSTATUS: 0,
  PENDING_REPORTSTATUS: 1,
  IN_PROGRESS_REPORTSTATUS: 2,
  SUCCESS_REPORTSTATUS: 3,
  ERROR_REPORTSTATUS: 4
};

/**
 * @enum {number}
 */
proto.fastcheckout.BankCode = {
  UNKNOWN_BANK: 0,
  DUMMY_BANK_PERSONAL: 261,
  DUMMY_BANK_BCA_PERSONAL: 600,
  MANDIRI_PERSONAL: 257,
  BCA_PERSONAL: 258,
  BNI_PERSONAL: 259,
  BRI_PERSONAL: 260,
  BCA_CORPORATE: 514,
  CIMB_PERSONAL: 264,
  PERMATA_PERSONAL: 265,
  BDO_PERSONAL: 262,
  BPI_PERSONAL: 263,
  PNB_PERSONAL: 406,
  UNIONBANK_PERSONAL: 407,
  UNIONBANK_CORPORATE: 410,
  METROBANK_PERSONAL: 408,
  RCBC_PERSONAL: 409,
  CLRB_PERSONAL: 411,
  KOMO_PERSONAL: 18,
  EASTWEST_PERSONAL: 19,
  GCASH_PERSONAL: 20,
  LANDBANK_PERSONAL: 21,
  SCB_PERSONAL: 768,
  KASIKORNBANK_PERSONAL: 405,
  GOPAY_PERSONAL: 412,
  TOKOPEDIA_PERSONAL: 413,
  TOKOPEDIA_CORPORATE: 414,
  MANDIRI_CORPORATE: 415,
  BNI_CORPORATE: 559,
  PERMATA_CORPORATE: 416,
  OVO_PERSONAL: 417,
  OCBC_PERSONAL: 418,
  SHOPEE_CORPORATE: 419,
  JAGO_PERSONAL: 420,
  SHOPEE_PERSONAL: 421,
  SHOPEE_VN_PERSONAL: 423,
  VCB_PERSONAL: 427
};

/**
 * @enum {number}
 */
proto.fastcheckout.CurrencyISO4217 = {
  UNKNOWN_CURRENCY: 0,
  AFN: 1,
  EUR: 2,
  ALL: 3,
  DZD: 4,
  USD: 5,
  AOA: 6,
  XCD: 7,
  ARS: 8,
  AMD: 9,
  AWG: 10,
  AUD: 11,
  AZN: 12,
  BSD: 13,
  BHD: 14,
  BDT: 15,
  BYR: 16,
  BZD: 17,
  XOF: 18,
  BMD: 19,
  BTN: 20,
  BOV: 21,
  BAM: 22,
  BWP: 23,
  NOK: 24,
  BRL: 25,
  SGD: 26,
  BGN: 27,
  BIF: 28,
  KHR: 29,
  XAF: 30,
  CAD: 31,
  CVE: 32,
  KYD: 33,
  CLP: 34,
  CNY: 35,
  COP: 36,
  KMF: 37,
  CDF: 38,
  NZD: 39,
  CRC: 40,
  HRK: 41,
  CUC: 42,
  CZK: 43,
  DKK: 44,
  DJF: 45,
  DOP: 46,
  EGP: 47,
  ERN: 48,
  ETB: 49,
  FKP: 50,
  FJD: 51,
  XPF: 52,
  GMD: 53,
  GEL: 54,
  GHS: 55,
  GIP: 56,
  GTQ: 57,
  GBP: 58,
  GNF: 59,
  GYD: 60,
  HNL: 61,
  HKD: 62,
  HUF: 63,
  ISK: 64,
  INR: 65,
  IDR: 66,
  IRR: 67,
  IQD: 68,
  IMP: 69,
  ILS: 70,
  JMD: 71,
  JPY: 72,
  JEP: 73,
  JOD: 74,
  KZT: 75,
  KES: 76,
  KPW: 77,
  KRW: 78,
  KWD: 79,
  KGS: 80,
  LAK: 81,
  LBP: 82,
  LSL: 83,
  LRD: 84,
  LYD: 85,
  CHF: 86,
  MKD: 87,
  MGA: 88,
  MWK: 89,
  MYR: 90,
  MVR: 91,
  MRO: 92,
  MUR: 93,
  MXN: 94,
  MDL: 95,
  MNT: 96,
  MAD: 97,
  MZN: 98,
  MMK: 99,
  NAD: 100,
  NPR: 101,
  ANG: 102,
  NIO: 103,
  NGN: 104,
  OMR: 105,
  PKR: 106,
  PGK: 107,
  PYG: 108,
  PEN: 109,
  PHP: 110,
  PLN: 111,
  QAR: 112,
  RON: 113,
  RUB: 114,
  RWF: 115,
  WST: 116,
  STD: 117,
  SAR: 118,
  RSD: 119,
  SCR: 120,
  SLL: 121,
  SBD: 122,
  SOS: 123,
  ZAR: 124,
  SSP: 125,
  LKR: 126,
  SHP: 127,
  SDG: 128,
  SRD: 129,
  SZL: 130,
  SEK: 131,
  SYP: 132,
  TWD: 133,
  TJS: 134,
  TZS: 135,
  THB: 136,
  TOP: 137,
  TTD: 138,
  TND: 139,
  TRY: 140,
  TMT: 141,
  UGX: 142,
  UAH: 143,
  ARE: 144,
  UYU: 145,
  UZS: 146,
  VUV: 147,
  VEF: 148,
  VND: 149,
  YER: 150,
  ZRN: 151,
  ZMW: 152
};

/**
 * @enum {number}
 */
proto.fastcheckout.BankInteractionMethod = {
  UNKNOWN_INTERACTION_METHOD: 0,
  SCRAPER: 1,
  API: 2,
  QRCODE: 3,
  APIWITHACCOUNTSELECTION: 4,
  LINK: 5,
  VISA: 6,
  MOBILE_SCRAPER: 7
};

/**
 * @enum {number}
 */
proto.fastcheckout.AccountInfoType = {
  ACCOUNTINFOTYPEUNKNOWN: 0,
  ACCOUNT: 1,
  PROFILE: 2,
  BANK: 3,
  MSISDN: 4
};

/**
 * @enum {number}
 */
proto.fastcheckout.CredentialType = {
  EMAIL: 0,
  TYPE_MSISDN: 1,
  TOKEN: 2,
  OAUTH: 3,
  OAUTH_CLIENT_CREDENTIAL: 4,
  EMPTY: 5,
  ACCESS_KEY: 6,
  INTG_SESSION_ID: 7,
  ACCOUNT_NUMBER: 8,
  MOBILE_NUMBER: 9
};

/**
 * @enum {number}
 */
proto.fastcheckout.PaymentChannelType = {
  _: 0,
  ID_LLG: 1,
  ID_RTGS: 2,
  PH_PESONET: 3,
  PH_INSTAPAY: 4,
  PH_PAYNAMICS: 5,
  ID_BANK_MEGA_IPG: 6,
  ID_SHOPEE: 7,
  WR_VISANET: 8,
  ID_DD: 9,
  PH_FUCENT: 10
};

/**
 * @enum {number}
 */
proto.fastcheckout.CountryISO3166 = {
  UNKNOWN: 0,
  ID: 1,
  PH: 2,
  TH: 3
};

/**
 * @enum {number}
 */
proto.fastcheckout.OptionalChallengeType = {
  OPTION_UNKNOWN: 0,
  OPTION_SMS: 1,
  OPTION_MGENCODE: 2,
  OPTION_PIN: 3
};

/**
 * @enum {number}
 */
proto.fastcheckout.IssueType = {
  UNKNOWN_ISSUETYPE: 0,
  BANK_ISSUE: 1,
  SYSTEM_ISSUE: 2,
  NO_SUCCESSFUL_TRANSACTIONS: 3
};

/**
 * @enum {number}
 */
proto.fastcheckout.InterestType = {
  UNKNOWN_INTEREST_TYPE: 0,
  PERCENTAGE: 1
};

goog.object.extend(exports, proto.fastcheckout);
